var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

var personalizedCoverScrollLockOptions = {
  reserveScrollBarGap: true,
  allowTouchMove: (el) => {
    return !!el.closest?.('#modal-personalized-cover .personalized-cover__main-content');
  },
};

window.headerTransparent;

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};



var Shopify = Shopify || {};

Shopify.money_format = "${{amount}}";

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(/[\.,].*$/, "");
  }
  var centsInt = parseInt(cents, 10);
  if (isNaN(centsInt)) {
    centsInt = 0;
  }

  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands === undefined ? "," : thousands;
    decimal = decimal === undefined ? "." : decimal;
    precision = (precision === undefined || isNaN(precision) || precision < 0) ? 2 : precision;

    if (isNaN(number) || number == null) {
      return "0";
    }

    var numberFloat = (number / 100.0).toFixed(precision);
    var parts = numberFloat.split(".");
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
    var centsPart = parts[1] ? decimal + parts[1] : "";

    if (number % 100 === 0 && precision > 0) {
      centsPart = "";
    }

    return dollars + centsPart;
  }

  var formatTypeMatch = formatString.match(placeholderRegex);
  var formatType = formatTypeMatch ? formatTypeMatch[1] : "amount";

  switch (formatType) {
    case "amount":
      value = formatWithDelimiters(centsInt, 2, ",", ".");
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(centsInt, 0, ",", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(centsInt, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(centsInt, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(centsInt, 2, "'", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(centsInt, 0, " ", ".");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(centsInt, 2, " ", ",");
      break;
    default:
      value = formatWithDelimiters(centsInt, 2, ",", ".");
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key)
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach(callback => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class PersonalizedCoverIOSScrollLock {
  static _preventScroll = null;
  static _preventGesture = null;
  static _isLocked = false;

  static lock() {
    if (this._isLocked) return;

    this._preventScroll = (e) => {
      if (e.target.closest('#modal-personalized-cover .personalized-cover__main-content')) return;
      e.preventDefault();
    };
    document.addEventListener('touchmove', this._preventScroll, { passive: false, capture: true });

    this._preventGesture = (e) => e.preventDefault();
    document.addEventListener('gesturestart', this._preventGesture);
    this._isLocked = true;
  }

  static unlock() {
    if (!this._isLocked) return;

    if (this._preventScroll) {
      document.removeEventListener('touchmove', this._preventScroll, { passive: false, capture: true });
      this._preventScroll = null;
    }

    if (this._preventGesture) {
      document.removeEventListener('gesturestart', this._preventGesture);
      this._preventGesture = null;
    }

    this._isLocked = false;
  }
}

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);

let alreadyDelegated = false;
class Popup {
  constructor(element, additionalOverlay, popupInPopup) {

    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = null;

    if (additionalOverlay == true) {
      this.pageOverlayElement = document.querySelector(".localizationOverlay");
    }
    else {
      this.pageOverlayElement = document.querySelector(".pageOverlay");
    }

    if (alreadyDelegated == false) {
      this.bindEvents();
    }

  }
  bindEvents() {
    alreadyDelegated = true;
    this.delegateBody.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );


    this.delegateBody.on(
      "close:other",
      this.closeModal.bind(this)
    );


    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();


    let controlId = event.target.getAttribute("aria-controls");

    if (!controlId) {
      controlId = event.target.closest("[aria-controls]").getAttribute("aria-controls");
    }

    this.activeModal = document.getElementById(controlId);
    if (this.activeModal.getAttribute("aria-hidden") === "false") return;

    this.activeModal.setAttribute("aria-hidden", "false");

    requestAnimationFrame(() => {
      if (responsive.matchesBreakpoint('lap_and_up') && !this.popupInsidePopup) {
        this.activeModal.dispatchEvent(
          new CustomEvent("close:other", { bubbles: true })
        );
      }


      this.activeModal.setAttribute("aria-expanded", "true");
      this.pageOverlayElement.classList.add("is-visible");


    });
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );


    const focus = this.activeModal.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
  }


  closeModal(e) {

    if (!this.popupInsidePopup) {
      this.activeModal = document.body.querySelector(
        '.Popup[aria-hidden="false"]'
      );
    } else {
      this.activeModal = document.body.querySelector(
        '.Popup.popup-inside-popup[aria-hidden="false"]'
      );
    }




    const handleModalClose = (e) => {
      if (this.activeModal.getAttribute("aria-expanded") === "false" && this.activeModal.getAttribute("aria-hidden") === "false") {

        this.activeModal.setAttribute("aria-hidden", "true");
        if (this.activeModal == null) return;
        this.pageOverlayElement.classList.remove("is-visible");
        this.pageOverlayElement.removeEventListener(
          "click",
          this.onClickOutsideListener
        );

        const focus = this.activeModal.querySelector("[data-scrollable]");
        bodyScrollLock.enableBodyScroll(focus);

      }
    };

    if (!this.activeModal) return;




    this.activeModal.setAttribute("aria-expanded", "false");
    if (this.activeModal.classList.contains('account__popup')) {

      this.activeModal.addEventListener('animationend', handleModalClose, { once: true });
    } else {
      this.activeModal.addEventListener('transitionend', handleModalClose, { once: true });
    }

    this.activeModal.removeAttribute("style");
  }
}

class Popup2 {
  constructor() {
    // Use a delegate for event handling on document.body.
    this.delegateBody = new Delegate(document.body);
    // Maintain a stack of active popups.
    this.activePopups = [];
    this.onPopupOpen = null;
    this.onPopupClose = null;
    this.bindEvents();
  }

  bindEvents() {
    // Bind a listener for clicks on toggle buttons.
    this.delegateBody.on(
      'click',
      '[data-action="toggle-popup"]',
      this.handleOpenOptions.bind(this)
    );

    // Listen for the custom "drawer:close-other" event to close all open popups.
    this.delegateBody.on(
      'drawer:close-other',
      this.handleDrawerCloseOther.bind(this)
    );

    this.delegateBody.on(
      'edit-img:open-popup',
      this.handleOpenOptions.bind(this)
    );

    // Bind keydown directly on the delegate element so it fires only once.
    this.delegateBody.on('keydown', this.handleEscape.bind(this));
  }

  // This method is called when a toggle button is clicked.
  handleOpenOptions(event) {
    event.stopPropagation();
    event.preventDefault();

    dynamicVars.syncHeight();
    const toggleButton = event.target.closest('[data-action="toggle-popup"]');
    if (toggleButton) {
      this.togglePopup(toggleButton);
      return;
    }

    // If a click occurs on the overlay of the top-most popup, close that popup.
    if (this.activePopups.length) {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      const overlay = this.getOverlayElement(topPopup);
      if (overlay && overlay.contains(event.target)) {
        this.closePopup(topPopup);
      }
    }
  }

  // Handle keydown events.
  // Only close the top-most popup when Esc is pressed.
  handleEscape(event) {
    if (event.key === 'Escape' && this.activePopups.length) {
      event.preventDefault();
      event.stopPropagation();
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if (topPopup.querySelector('[data-action="toggle-popup"]')) {
        topPopup.querySelector('[data-action="toggle-popup"]').click();
      } else {
        this.closePopup(topPopup);
      }

    }
  }

  // Toggle the popup associated with the given button.
  togglePopup(button) {
    const popupId = button.getAttribute('aria-controls');
    if (!popupId) return;

    const popupElement = document.getElementById(popupId);
    if (!popupElement) return;

    // Determine if this popup should be treated as a child popup.
    const isChild = button.getAttribute('data-child-popup') === 'true';

    // If the popup is already open, close it; otherwise, open it.
    if (popupElement.getAttribute('aria-hidden') === 'false') {
      this.closePopup(popupElement);
    } else {
      if (popupElement.id === "personalization-cart__preview-modal") {
        this.openPopup(popupElement, isChild, button);
      }
      this.openPopup(popupElement, isChild);
    }
  }

  // Open the popup element.
  // If it's not a child popup, close all currently open popups.
  openPopup(popupElement, isChild = false, clickedButton = null) {
    // Mark the popup element as a child (or not) for later checks.
    popupElement._isChild = isChild;

    // Ensure the popup is visible before starting any animations.
    popupElement.style.display = '';

    // If this is a parent popup, close any other open popups.
    if (!isChild) {
      while (this.activePopups.length) {
        this._closePopup(this.activePopups.pop());
      }
    }

    popupElement.setAttribute('aria-hidden', 'false');
    popupElement.removeAttribute('inert');

    // Lock as early as possible to avoid a first-frame body scroll leak on mobile.
    if (popupElement.id === 'modal-personalized-cover') {
      const earlyScrollable = popupElement.querySelector('[data-scrollable]');
      if (earlyScrollable) {
        bodyScrollLock.disableBodyScroll(
          earlyScrollable,
          personalizedCoverScrollLockOptions
        );
      }
      PersonalizedCoverIOSScrollLock.lock();
    }

    requestAnimationFrame(() => {
      popupElement.setAttribute('aria-expanded', 'true');
      if (typeof this.onPopupOpen === 'function') {
        this.onPopupOpen(popupElement);
      }
    });

    if (popupElement.id === 'modal-personalized-cover') {
      document.dispatchEvent(
        new CustomEvent("popup:opened", { bubbles: true })
      );

    }

    if (popupElement.id === "personalization-cover__preview-modal") {
      document.dispatchEvent(
        new CustomEvent("preview:opened", { bubbles: true })
      );

    }

    if (popupElement.id === "personalization-cart__preview-modal" && clickedButton) {
      const imageUrl = clickedButton.dataset.editUrl;
      document.dispatchEvent(
        new CustomEvent("preview-cart:opened", {
          bubbles: true,
          detail: { imageUrl },
        })
      );
    }

    // Store the scrollable element reference on the popup for later use.
    const focus = popupElement.querySelector('[data-scrollable]');

    if (focus) {
      popupElement._scrollableElement = focus;
    }

    trapFocus(popupElement);
    // If the popup specifies an overlay, find it, display it, and attach a click listener.
    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.add('is-visible');
      const handleOverlayClick = (e) => {
        e.preventDefault();
        this.closePopup(popupElement);
      };
      // Store the handler so it can be removed later.
      popupElement._overlayClickHandler = handleOverlayClick;
      overlay.addEventListener('click', handleOverlayClick);
    }

    // Push this popup onto the active stack.
    this.activePopups.push(popupElement);
    this.syncBodyScrollLockWithPopupStack();

    // Reopen safety: force-cover lock on personalized modal root.
    if (popupElement.id === "modal-personalized-cover") {
      const rootScrollable = popupElement.querySelector('[data-scrollable]');
      if (rootScrollable) {
        bodyScrollLock.disableBodyScroll(
          rootScrollable,
          personalizedCoverScrollLockOptions
        );
      }
      PersonalizedCoverIOSScrollLock.lock();
    }
  }

  /**
   * Keep body scroll locked to the topmost popup only (fixes nested modal-edit-img on iOS).
   */
  syncBodyScrollLockWithPopupStack() {
    bodyScrollLock.clearAllBodyScrollLocks();

    const hasPersonalizedCoverOpen = this.activePopups.some(
      (popup) => popup.id === "modal-personalized-cover"
    );
    if (hasPersonalizedCoverOpen) {
      PersonalizedCoverIOSScrollLock.lock();
    } else {
      PersonalizedCoverIOSScrollLock.unlock();
    }

    if (this.activePopups.length === 0) {
      return;
    }

    const topPopup = this.activePopups[this.activePopups.length - 1];

    let scrollableElement =
      topPopup._scrollableElement ||
      topPopup.querySelector?.("[data-scrollable]") ||
      null;

    if (!scrollableElement && hasPersonalizedCoverOpen) {
      const coverRootPopup = this.activePopups.find(
        (popup) => popup.id === "modal-personalized-cover"
      );
      scrollableElement =
        coverRootPopup?._scrollableElement ||
        coverRootPopup?.querySelector?.("[data-scrollable]") ||
        null;
    }

    if (!scrollableElement) {
      // Some popups (e.g. personalization-cart preview) have no [data-scrollable].
      // Lock the popup root itself so body cannot scroll behind it.
      scrollableElement = topPopup;
    }

    if (scrollableElement) {
      const scrollLockOptions =
        hasPersonalizedCoverOpen
          ? personalizedCoverScrollLockOptions
          : bodyScrollLockOptions;
      bodyScrollLock.disableBodyScroll(
        scrollableElement,
        scrollLockOptions
      );
    }
  }

  // Close the popup element.
  closePopup(popupElement) {
    const index = this.activePopups.indexOf(popupElement);

    if (index !== -1) {
      this._closePopup(popupElement);
      this.activePopups.splice(index, 1);

      if (popupElement.id === "modal-personalized-cover") {
        // Close any child popups
        if (this.activePopups.length > 0) {
          while (this.activePopups.length > 0) {
            const childPopup = this.activePopups.pop();
            this._closePopup(childPopup);
          }
        }
        // Hard-reset locks so reopening the personalized modal starts clean.
        bodyScrollLock.clearAllBodyScrollLocks();
        PersonalizedCoverIOSScrollLock.unlock();
      }

      this.syncBodyScrollLockWithPopupStack();
    }

    if (popupElement.id === "modal-personalized-cover") {
      document.dispatchEvent(
        new CustomEvent("exit:personalization", { bubbles: true })
      );
    }
  }


  // Internal method to remove open styles and attributes from the popup,
  // then wait for the transition to finish before setting display: none.
  _closePopup(popupElement) {
    popupElement.setAttribute('aria-expanded', 'false');

    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.remove('is-visible');
      if (popupElement._overlayClickHandler) {
        overlay.removeEventListener('click', popupElement._overlayClickHandler);
        delete popupElement._overlayClickHandler;
      }
    }

    removeTrapFocus(popupElement);

    const transitionEndHandler = () => {
      popupElement.setAttribute('aria-hidden', 'true');
      popupElement.setAttribute('inert', '');
      popupElement.removeEventListener('transitionend', transitionEndHandler);
      // Trigger the close callback after the transition ends.
      if (typeof this.onPopupClose === 'function') {
        this.onPopupClose(popupElement);
      }
    };

    setTimeout(() => {
      popupElement.setAttribute('aria-hidden', 'true');
      popupElement.setAttribute('inert', '');
      popupElement.removeEventListener('transitionend', transitionEndHandler);
    }, 500);

    popupElement.addEventListener('transitionend', transitionEndHandler);
  }

  // Method to handle the custom event "drawer:close-other".
  // It closes all currently open popups.
  handleDrawerCloseOther(event) {
    event.preventDefault();
    this.closeAllPopups();
  }

  // Method to close all open popups.
  closeAllPopups() {
    while (this.activePopups.length) {
      const popup = this.activePopups.pop();
      this._closePopup(popup);
    }
    this.syncBodyScrollLockWithPopupStack();
  }

  // Retrieve the overlay element based on the popup's data-overlay attribute.
  getOverlayElement(popupElement) {
    const overlayClass = popupElement.getAttribute('data-overlay');
    if (overlayClass) {
      return document.querySelector(`.${overlayClass}`);
    }
    return null;
  }
}

window.globalPopup = new Popup2();

(function initVideoRedirectModalDelegate() {
  const delegateVideoRedirectModal = new Delegate(document.body);

  delegateVideoRedirectModal.on(
    "click",
    '[data-action="toggle-popup"][aria-controls="video-redirect-confirm-modal"]',
    function () {
      window.__videoRedirectPendingUrl = null;
    }
  );

  delegateVideoRedirectModal.on(
    "click",
    '[data-action="video-redirect-confirm-open"]',
    function (e) {
      e.preventDefault();
      const url = window.__videoRedirectPendingUrl;
      if (url) {
        window.open(url, "_blank", "noopener,noreferrer");
      }
      window.__videoRedirectPendingUrl = null;
      const modal = document.getElementById("video-redirect-confirm-modal");
      if (modal && window.globalPopup) {
        window.globalPopup.closePopup(modal);
      }
    }
  );
})();




class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
    this.applyColorScheme();
  }

  applyColorScheme() {
    const productModule = document.querySelector('.product-module');
    const colorGroupClass = Array.from(productModule.classList).find(className => className.includes('colorGroup'));
    document.querySelector('.pswp').classList.add(colorGroupClass);
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".product-module__product-slider--image",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );

    this.onPointerUpBinder = this.onPointerUp.bind(this);
    this.onPointerDownBinder = this.onPointerDown.bind(this);
    responsive.addBreakpointListener("lap_and_up");
    this.delegateRoot.on(
      "breakpoint:lap_and_up",
      this.toggleMoveZoom.bind(this)
    );
    this.toggleMoveZoom();

    if (responsive.matchesBreakpoint('pocket') && document.querySelector('[data-zoom-type="image"]')) {
      this.delegateElement.on(
        "click",
        '.product-module__product-slider--image',
        this.initPhotoSwipeFromPhotoTap.bind(this)
      );
    }
  }

  toggleMoveZoom(e) {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.delegateRoot.on(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.on("pointerup", "[data-move]", this.onPointerUpBinder);
    } else {
      this.delegateRoot.off(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.off("pointerup", "[data-move]", this.onPointerUpBinder);
    }
  }

  onPointerDown(e) {
    this.timeout = setTimeout(() => {
      e.target.closest(".pswp__container")?.classList.add("move");
    }, 150);
  }

  onPointerUp(e) {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
    e.target.closest(".pswp__container")?.classList.remove("move");
  }

  photoswiperClose() {
    if (this.photoSwipeInstance) {
      this.photoSwipeInstance.close;
    }
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  sortImageArray(images) {
    return images.sort((a, b) => {
      const positionA = parseInt(a.closest(".product-module__product-slider-element").getAttribute("data-image-position"));
      const positionB = parseInt(b.closest(".product-module__product-slider-element").getAttribute("data-image-position"));
      return positionA - positionB;
    });
  }

  initPhotoSwipeFromPhotoTap(e) {
    if (e.target.closest('[data-action="open-product-zoom"]') || e.target.closest('.product-module__product-highlight')) return;
    e.target.closest('.product-module__product-slider-cell').querySelector('[data-action="open-product-zoom"]').click();
  }

  initPhotoSwipe(event, target) {
    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (
          item.classList.contains("product-module__product-slider-cell--zoom")
        ) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
    } else {
      images.push(
        document.querySelector(".product-module__product-slider-image")
      );
    }

    const imagePosition = parseInt(
      target
        .nextElementSibling
        .getAttribute("data-image-position")
    );

    images = this.sortImageArray(images);

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(imagePosition)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (
      responsive.matchesBreakpoint("pocket") ||
      event.target.closest(".product-module__product-highlight")
    ) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    var images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (
        item.classList.contains("product-module__product-slider-cell--zoom") &&
        item.querySelector("img")
      ) {
        images.push(item.querySelector("img"));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(
      target
        .querySelector(".product-module__product-slider-element")
        .getAttribute("data-image-position")
    );

    images = this.sortImageArray(images);

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      imagePosition
    );
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = responsive.matchesBreakpoint("pocket") ? 1200 : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".product-module__product-slider-cell--zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.selectorsOverlay = document.querySelector(".selectorsOverlay");
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
      ".RevolutionSelectbox--Button"
    );

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {

        this.pageOverlayElement = document.querySelector(
          ".selectorsOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }

    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.domDelegate.on(
      "keydown",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  selectboxChange(e) {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }

    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);

    // Remove the "selected" attribute from the previously selected option
    var previouslySelectedOption = selEl.querySelector('option[selected]');
    if (previouslySelectedOption) {
      previouslySelectedOption.removeAttribute("selected");
    }

    // Find the <option> element that corresponds to the selected value
    var optionEl = selEl.querySelector(`option[value="${value}"]`);
    if (optionEl) {
      optionEl.setAttribute("selected", "true"); // Set the new option as selected
    }

    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));

      if (selEl.id == 'Size') {

        this.element.dispatchEvent(
          new CustomEvent("change:size", {
            bubbles: true,
          })
        );
      }

    } else {
      selEl.value = value;
    }
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if (this.element.classList.contains("dropdownSelector")) {
      this.element
        .querySelector('.RevolutionSelectbox--Item[disabled="true"]')
        .removeAttribute("disabled");
      event.target.setAttribute("disabled", "true");
    }
    if (event.target.dataset.selectboxid == 'country-selector__country-code') {
      this.element.dispatchEvent(
        new CustomEvent("change:countrySelector", {
          bubbles: true,
          detail: {
            currency: event.target.dataset.currency,
            country: event.target.value,
            languages: event.target.dataset.languages
          },
        })
      );

    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector(
      '[selected="selected"]'
    ),

      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem && this.connectedSelect != 'country_code') {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  findAndScrollToMatch(contentElement, searchQuery) {
    const items = Array.from(contentElement.querySelectorAll(".RevolutionSelectbox--Item"));

    const matchedItem = items.find(item => {
      const itemText = item.textContent.toLowerCase().trim();
      return itemText.startsWith(searchQuery.trim());
    });

    if (matchedItem) {
      matchedItem.focus();
    }
  }

  initSearchWithinDropdown(contentElement) {
    let searchQuery = "";

    this.keydownListener = (event) => {
      if (!this.resetQuery) {
        this.resetQuery = setTimeout(() => {
          searchQuery = "";
          this.resetQuery = null;
        }, 500);
      }

      searchQuery += event.key.toLowerCase();
      if (searchQuery.length > 0) {
        this.findAndScrollToMatch(contentElement, searchQuery);
      }
    };

    window.addEventListener("keydown", this.keydownListener);
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    if (!this.element.closest("#modal-country") && !this.element.closest("#modal-edit-img")) {
      this.element.dispatchEvent(
        new CustomEvent("close:other", { bubbles: true })
      );
    }

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );
      const focus = this.element.querySelector("[data-scrollable]");

      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      trapFocus(this.mainDropdown);
    }

    if (this.element.closest("#modal-country") && responsive.matchesBreakpoint('pocket')) {
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );

    target.setAttribute("aria-expanded", "true");

    contentElement.style.display = "block";
    contentElement.style.visibility = 'hidden';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (this.connectedSelect == 'country_code') {
          contentElement.style.visibility = 'visible';
          contentElement.style.height = '10.625rem';
        } else {
          contentElement.style.height = '';
          const height = contentElement.offsetHeight;
          contentElement.style.height = '0';
          contentElement.style.visibility = 'visible';
          requestAnimationFrame(() => {
            contentElement.style.height = `${height}px`;
          });
        }
      });
    });

    if (this.popover) {
      setTimeout(() => {
        contentElement.setAttribute("aria-hidden", "false");
      }, 20);
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
    this.initSearchWithinDropdown(contentElement);
  }

  closeDropdown(target) {
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    closestDropdown.querySelector(
      ".RevolutionSelectbox--Content"
    ).style.height = "0px";
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 300);

    if (this.keydownListener) {
      window.removeEventListener("keydown", this.keydownListener);
      this.keydownListener = null;
    }

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );

      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.enableBodyScroll(focus);

    }


    if (this.element.closest("#modal-country") && responsive.matchesBreakpoint('pocket')) {
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.enableBodyScroll(focus);
    }

    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='images-to-cart']",
      this.addPrintsToCart.bind(this)
    );

  }

  async addPrintsToCart(event, target) {
    const _this = this;

    event.preventDefault();
    const addToCartButton = event.target;
    this.pageLoader.style.width = 90 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    const formElement = event.target.closest("form");
    const formHelper = new Form();

    const formElementSerialized = formHelper.serialize(formElement);
    const items = [];
    const keys = Object.keys(formElementSerialized);

    const customProperties = {
      _upload_token: document.getElementById("custom_property").value,
      _order_token: document.getElementById("order_token").value,
      _order_timestamp: localStorage.getItem("upload_timestamp") || "",
    };

    keys.forEach((key) => {

      if (key !== "event_id") {
        // Retrieve the product element by its name attribute and then get its data-id.
        const productElement = document.body.querySelector(`#${key}`);

        const productID = productElement ? productElement.getAttribute("data-id") : null;

        if (productID) {
          const quant = parseInt(productElement.dataset.quantity || "0", 10);
          if (quant > 0) {
            items.push({
              id: productID,
              quantity: quant,
              properties: {
                _upload_token: customProperties._upload_token,
                _order_token: customProperties._order_token,
                _is_photo_print: "true",
              },
            });
          }
        }
      }
    });

    let attributesToSet = {};
    if (!customProperties._order_token) {
      customProperties._order_token = localStorage.getItem('security_token');
    }
    if (customProperties._order_token) {
      attributesToSet.private_cart_property = customProperties._order_token;
      attributesToSet.private_cart_timestamp = customProperties._order_timestamp || null;
      attributesToSet.photo_print_order = true;
    } else {
      attributesToSet.private_cart_property = null;
      attributesToSet.private_cart_timestamp = null;
      attributesToSet.photo_print_order = null;
    }

    let sessionToken =
      customProperties._order_token || localStorage.getItem("security_token");

    if (items.length === 0) {
      addToCartButton.removeAttribute("disabled");
      this.pageLoader.style.width = "0%";
      alert("Select at least one print size and quantity before adding to cart.");
      return;
    }

    if (sessionToken && typeof ensureUploadSessionBeforeAtc === "function") {
      const sessionGate = await ensureUploadSessionBeforeAtc({
        sessionToken,
        root: document,
      });
      if (!sessionGate.ok) {
        addToCartButton.removeAttribute("disabled");
        this.pageLoader.style.width = "0%";
        alert(sessionGate.message || uploadSessionBlockMessage(sessionGate.sessionStatus));
        return;
      }
      sessionToken = sessionGate.sessionToken || sessionToken;
      await syncUploadCartSessionAttributes(
        sessionToken,
        attributesToSet.private_cart_timestamp ||
          localStorage.getItem("upload_timestamp") ||
          String(Date.now())
      );
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        items: items,
        attributes: attributesToSet
      }),
    })
      .then(response => {
        if (!response.ok) {
          return response.json().then(errorContent => {
            throw { status: response.status, content: errorContent };
          }).catch(() => {
            throw { status: response.status, content: { description: 'Unknown error adding to cart.' } };
          });
        }
        return response.json();
      })
      .then(cart => {
        localStorage.removeItem('upload_token');
        addToCartButton.removeAttribute("disabled");

        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: _this.currentVariant,
              quantity: keys.length
            },
          })
        );

        if (window.globalPopup && typeof window.globalPopup.closeAllPopups === 'function') {
          window.globalPopup.closeAllPopups();
        }

        _this.element.dispatchEvent(
          new CustomEvent("reset:reset-upload", {
            bubbles: true
          })
        );
      })
      .catch(error => {
        console.error("Error during cart add/update:", error);
        const errorMessageElement = document.createElement("span");
        errorMessageElement.className = "ProductForm__Error Alert Alert--error u-p4";
        errorMessageElement.innerHTML = (error.content && error.content.description) ? error.content.description : 'Could not add item(s) to cart.';
        addToCartButton.removeAttribute("disabled");
        addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
        setTimeout(() => {
          if (errorMessageElement.parentNode) {
            errorMessageElement.remove();
          }
        }, 3000); // Adjusted timeout from 1500 to 3000 for better visibility
      });

  }

  addToCart(e, target) {
    var _this = this;
    event.preventDefault();
    if (target.closest('[data-action="add-to-cart"]').hasAttribute('disabled')) return;
    var addToCartButton = event.target;
    this.pageLoader.style.width = 90 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    if (!formElement) {
      const formId = event.target.getAttribute('for');
      if (!formId) {
        console.error('No form ID found');
        return;
      }

      const container = document.querySelector('.product-module__product-actions');
      if (!container) {
        console.error('Container not found');
        return;
      }

      formElement = container.querySelector('#' + CSS.escape(formId));
    }
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.theme.cartMode === 'page') {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.querySelector(".product-error");
            if (errorMessageElement.innerHTML.trim() !== '') return;
            errorMessageElement.innerHTML = content["description"];
            errorMessageElement.setAttribute("aria-hidden", "false");
            addToCartButton.removeAttribute("disabled");
            setTimeout(function () {
              errorMessageElement.setAttribute("aria-hidden", "true");
              setTimeout(function () {
                errorMessageElement.innerHTML = "";
              }, 300);
            }, 2500);
          }
        });
      }
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.lock = false;
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );


    let selector;
    switch (this.breakpoint) {
      case "desktop":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown, true);
      }
    });

    DropdownButton.setAttribute("aria-expanded", "true");
    new RevolutionAnimation(DropdownContent, "true").slideDown();

    setTimeout(() => {
      this.lock = false;
    }, 300);
  }

  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
    setTimeout(() => {
      if (DropdownContent.getAttribute("aria-hidden") == "false") {
        DropdownContent.setAttribute("aria-hidden", "true");
      }

      this.lock = false;
    }, 300);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);
      }
    }
  }
}

const allDropdowns = new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (this.element.querySelector('.swiper-slide img')) {
      this.slidesToPreload = this.getSlidesPerView(this.initialConfig);
    }

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  getSlidesPerView(config) {
    const calculateSlides = (view) => Math.ceil(view >= 3 ? 3 : view || 3);

    const mobileSlidesPerView = config.slidesPerGroup ? calculateSlides(config.slidesPerGroup) : calculateSlides(config.slidesPerView);
    const desktopSlidesPerView = config.breakpoints && config.breakpoints['1025']
      ? (config.breakpoints['1025'].slidesPerGroup ? calculateSlides(config.breakpoints['1025'].slidesPerGroup) : calculateSlides(config.breakpoints['1025'].slidesPerView))
      : mobileSlidesPerView;

    const n = responsive.matchesBreakpoint('pocket') ? mobileSlidesPerView : desktopSlidesPerView;

    return n;
  }

  preloadNextSlides() {
    const n = this.getSlidesPerView(this.initialConfig);

    let delay = 0;
    if (!this.firstTime) {
      delay = 250;
      this.firstTime = !this.firstTime;
    }

    setTimeout(() => {
      this.swiperElement
        .slides
        .slice(this.swiperElement.activeIndex, this.swiperElement.activeIndex + n + 1)
        .map(slide => slide.querySelector('img[loading="lazy"]'))
        .forEach(img => img && img.setAttribute('loading', 'eager'));
    }, delay)
  };

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("realIndexChange", function () {
      if (_this.slidesToPreload) {
        _this.preloadNextSlides();
      }

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }

  destroy() {
    this.swiperElement.destroy();
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.onDrawerClose = options["onDrawerClose"] || function () { };
    this.onDrawerOpen = options["onDrawerOpen"] || function () { };


    this.pageOverlayElement = document.querySelector(".pageOverlay");


    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    responsive.addResizeListener(this, this.calculateMaxHeightListener);
    this.delegateBody.on("close:other", this._closeListener);
  }

  maxHeight() {
    this.element.style.height = window.innerHeight + "px";

    if (this.element.getAttribute("id") == "cart-drawer") {
      const footer = this.element.querySelector(".cart-drawer__footer");
      let footerHeight = 0;
      if (footer !== null && footer.offsetHeight > 0) {
        footerHeight = footer.offsetHeight;
        document.documentElement.style.setProperty(
          "--cart-drawer__footer-height",
          `${footerHeight}px`
        );
      }

      const headerEl = this.element.querySelector(".cart-drawer__header");
      let header = 0;
      if (headerEl) {
        header = headerEl.offsetHeight;
        document.documentElement.style.setProperty(
          "--cart-drawer__header-height",
          `${header}px`
        );
      }

      const itemWrapper = this.element.querySelector(".cart-items--Wrapper");

      if (itemWrapper !== null) {
        itemWrapper.style.height =
          window.innerHeight - footerHeight - header + "px";
      }
    } else {
      const content = this.element.querySelector(".Drawer--Content");
      const header = this.element.querySelector(".Drawer--Header")?.offsetHeight || 0;
      const footer = this.element.querySelector(".Drawer--Footer")?.offsetHeight || 0;

      if (content) {
        const contentHeight = window.innerHeight - header - footer;
        content.style.height = contentHeight + "px";

        const loader = this.element.querySelector(".spinningLoader");
        if (loader && this.element.id === "favorites-drawer") {
          loader.style.height = contentHeight + "px";
          loader.style.top = header + "px";
        }
      }
    }
  }

  toggleDrawer(event) {


    event.preventDefault();
    this.isOpen ? this.closeDrawer(event) : this.openDrawer(event);
  }

  openDrawer(event) {
    if (this.isOpen) {
      return;
    }
    if (event && event.target.dataset.toggleId === "sortby") {
      event.target.setAttribute('aria-expanded', 'true')
    }

    this.element.dispatchEvent(
      new CustomEvent("close:other", { bubbles: true })
    );

    if (this.element.getAttribute("id") == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );

    }



    this.element.setAttribute("aria-hidden", "false");

    requestAnimationFrame(() => {
      this.element.setAttribute("aria-expanded", "true");
      this.maxHeight();
    });

    if (this.element.id != "mobile-menu" && this.element.id != "sortby") {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this._closeListener);
    }

    if (this.element.id === "sortby") {
      this.pageOverlayElementSort = document.querySelector(".sortByOverlay");

      this.pageOverlayElementSort.classList.add("is-visible");
      this.pageOverlayElementSort.addEventListener("click", this._closeListener);

    }

    if (!(this.element.id === "sortby" && responsive.matchesBreakpoint('lap-and-up'))) {

      this.focus = this.element.querySelector("[data-scrollable]");

      bodyScrollLock.disableBodyScroll(this.focus, bodyScrollLockOptions);

    }
    this.isOpen = true;
    this.onDrawerOpen();
    trapFocus(this.element);
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    this.eventTarget = event.target;
    this.eventTarget.classList.add('is-disabled');

    if (event) {
      event.preventDefault();
    }

    this.element.setAttribute("aria-expanded", "false");
    this.event = event;
    this.transitionEndHandler = this.handleTransitionEnd.bind(this);

    if (this.element.id === "mobile-menu") {
      this.element.addEventListener("transitionend", this.transitionEndHandler);
    } else {
      this.element.addEventListener("animationend", this.transitionEndHandler);
    }


    if (this.element.id != "mobile-menu" && this.element.id != "sortby") {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener("click", this._closeListener);
    }

    if (this.element.id === "sortby") {
      const sortByBtn = document.body.querySelector('.FilterBar--item[data-toggle-id="sortby"]');
      sortByBtn.setAttribute('aria-expanded', 'false');
      this.pageOverlayElementSort.classList.remove("is-visible");
      this.pageOverlayElementSort.removeEventListener("click", this._closeListener);

    }

    this.onDrawerClose();
    removeTrapFocus(this.element);
    this.isOpen = false;
  }


  handleTransitionEnd(event, target) {
    this.eventTarget.classList.remove('is-disabled');
    if (event.target !== this.element) return;
    this.element.setAttribute("aria-hidden", "true");

    bodyScrollLock.enableBodyScroll(this.focus);

    this.element.removeEventListener(
      "animationend",
      this.transitionEndHandler
    );
    this.element.removeEventListener(
      "transitionend",
      this.transitionEndHandler
    );
  }

}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate = node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  elementClipRevealFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }

      // Define the clip path animation
      const clipReveal = [
        { clipPath: "inset(100% 0 0 0)", opacity: "0" },
        { clipPath: "inset(0 0 0 0)", opacity: "1" },
      ];

      // Animate the wrapper
      setTimeout(() => {
        item.animate(clipReveal, {
          duration: window.theme.animationDuration,
          fill: "forwards",
          easing: "cubic-bezier(0.23, 1, 0.32, 1)",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }


  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }

  elementScaleOutPure(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0.35" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }



  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {

    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {

          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            if (result.target.classList.contains('desktop') && responsive.matchesBreakpoint('pocket')) {
              result.target.setAttribute("data-loaded-mobile", true);
            } else {
              elements.push(result.target);
            }
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          elementScaleOut: 'elementScaleOut',
          elementScaleOutPure: 'elementScaleOutPure',
          elementClipRevealFromRight: "elementClipRevealFromRight",
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.25 }
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.toggleAddButton();
      this.input.dispatchEvent(this.changeEvent);
    }

    if (this.options["noVariants"] == "true" && this.options["data_avaliable"]) {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelectorAll(".product-module__product-atc"),
      addButtonInner = document.querySelectorAll(".product-module__product-atc .ButtonText"),
      quantityEl = document.querySelector(".product-module__quantity-input");
    if (quantityEl) {
      quantity = quantityEl.value;
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        `<svg class="mr-m" xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.384644 6.10577H15.6154V19.0289H0.384644V6.10577ZM1.76926 7.49039V17.6442H14.2308V7.49039H1.76926Z" fill="black"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00007 0.971161C7.53791 0.971161 7.08029 1.06219 6.65331 1.23905C6.22634 1.4159 5.83838 1.67513 5.51159 2.00192C5.1848 2.32871 4.92558 2.71667 4.74872 3.14364C4.57186 3.57061 4.48083 4.02824 4.48083 4.49039V9.10578H5.98083V4.49039C5.98083 4.22522 6.03306 3.96265 6.13454 3.71767C6.23602 3.47268 6.38475 3.25008 6.57225 3.06258C6.75976 2.87508 6.98236 2.72634 7.22734 2.62487C7.47232 2.52339 7.7349 2.47116 8.00007 2.47116C8.26523 2.47116 8.52781 2.52339 8.77279 2.62487C9.01778 2.72634 9.24037 2.87508 9.42788 3.06258C9.61538 3.25008 9.76412 3.47268 9.86559 3.71767C9.96707 3.96265 10.0193 4.22522 10.0193 4.49039V9.10578H11.5193V4.49039C11.5193 4.02824 11.4283 3.57061 11.2514 3.14364C11.0746 2.71667 10.8153 2.32871 10.4885 2.00192C10.1617 1.67513 9.77379 1.4159 9.34682 1.23905C8.91984 1.06219 8.46222 0.971161 8.00007 0.971161Z" fill="black"/>    
    </svg>`;
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    addButton.forEach(button => button.removeAttribute("disabled"));
    addButton.forEach(button => button.classList.remove("product-module__product-atc--sold-out"));
    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='product-module__atc-price u-pb1'>|&nbsp;" +
        Shopify.formatMoney(
          this.options["price"] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } else {
      var priceElement = "";
    }

    addButtonInner.forEach((btn) => {
      btn.innerHTML = buySvg + window.variantStrings.addToCart + priceElement;
    });
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
  copped
) {
  if (!copped) this.countryEl = document.getElementById(country_domid);
  else this.countryEl = country_domid;
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  if (this.provinceEl) this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    if (this.provinceEl) {
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = "none";
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement("option");
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }

        this.provinceContainer.style.display = "";
      }
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class PreorderInfo extends HTMLElement {
  constructor() {
    super();
    this.delegateElement = new Delegate(this);
    this.delegateBody = new Delegate(document.body);
    this.infoPanel = this.querySelector('.product-module__preorder-info');
    this.toggleBtn = this.querySelector('.product-module__preorder-info-toggle');
    this.scrollHandler = this.close.bind(this);
    if (this.infoPanel && this.toggleBtn) {
      this.delegateElement.on('click', '.product-module__preorder-info-toggle', this.toggle.bind(this));
    }
  }

  toggle(e) {
    if (window.innerWidth >= 1025) return;
    e.stopPropagation();
    if (this.infoPanel.classList.contains('is-active')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.infoPanel.classList.add('is-active');
    this.toggleBtn.classList.add('is-active');
    this.delegateBody.on('click', this.onBodyClick.bind(this));
    window.addEventListener('scroll', this.scrollHandler, { passive: true });
  }

  onBodyClick(e) {
    if (this.contains(e.target)) return;
    this.close();
  }

  close() {
    this.infoPanel.classList.remove('is-active');
    this.toggleBtn.classList.remove('is-active');
    this.delegateBody.off('click');
    window.removeEventListener('scroll', this.scrollHandler);
  }
}

customElements.define("preorder-info", PreorderInfo);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    // Parse options from the element's data-settings attribute
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    // Get the target countdown day from options (e.g., Monday = 1, etc.)
    const countdownDay = parseInt(this.options.countdownDays);

    // Get the current time in hours and minutes
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();

    // Parse target time from the options (assuming '12:00' format)
    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);

    // Determine if the target time is before the current time
    const isBefore = targetHours < currentHours || (targetHours === currentHours && targetMinutes < currentMinutes);

    // Calculate how many days ahead the target day is (handles weekly recurring countdowns)
    this.dayDifference = countdownDay - todaysDay;
    if (this.dayDifference < 0 || (this.dayDifference === 0 && isBefore)) {
      this.dayDifference += 7; // If the countdown day is earlier or passed today, add 7 days
    }

    // Get the target elements for displaying the countdown
    this.counters = this.element.querySelectorAll(".component-countdown_span");

    // Start the countdown, updating every second
    setInterval(this.countDown.bind(this), 1000);
  }

  // Countdown method that updates every second
  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();

    // Create the target date based on the dayDifference and target time
    let countDate = new Date();

    if (this.options['countdownType'] === 'reccuring') {
      // Add the day difference to move the target to the correct weekday
      countDate.setDate(countDate.getDate() + this.dayDifference);

      // Set the target time (hours and minutes) on that day
      const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
      countDate.setHours(targetHours, targetMinutes, 0, 0);

      // If the target time is the same as now (or has passed), move to the next occurrence of the day
      if (this.dayDifference === 0 && targetHours === currentHours && targetMinutes === currentMinutes) {
        // Move the target to the next week's occurrence (7 days later)
        countDate.setDate(countDate.getDate() + 7);
      }
    } else if (this.options['countdownType'] === 'to_date') {
      // For a "to_date" countdown, use the exact date and time from the options
      countDate = new Date(`${this.options.countdownDate} ${this.options.countdownTime}`);
    } else if (this.options['countdownType'] === 'every_day') {
      // Handle "next day" countdown (excluding weekends)
      const todaysDay = dateNow.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6

      if (todaysDay === 5) { // If today is Friday, next countdown is for Monday
        countDate.setDate(countDate.getDate() + 3); // Skip to Monday
      } else if (todaysDay === 6) { // If today is Saturday, set the countdown for Monday
        countDate.setDate(countDate.getDate() + 2); // Skip to Monday
      } else { // Otherwise, set the countdown to the next day
        countDate.setDate(countDate.getDate() + 1);
      }

      // Set the target time for the next day
      const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
      countDate.setHours(targetHours, targetMinutes, 0, 0);

      // If the target time is before the current time, adjust the countdown to the previous day
      if (targetHours > currentHours || (targetHours === currentHours && targetMinutes > currentMinutes)) {
        countDate.setDate(countDate.getDate() - 1);
      }
    }


    // Calculate the time difference between now and the target date
    const difference = countDate - dateNow;

    // Time constants in milliseconds
    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    // Calculate remaining days, hours, minutes, and seconds
    let textDays = Math.floor(difference / days);
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    // Format the hours, minutes, and seconds for display
    const formatHours = textHours < 10 ? `0${textHours}` : textHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    // Update the display with the countdown values
    if (textDays > 0) {
      this.counters.forEach(counter => counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`);
    } else {
      this.counters.forEach(counter => counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`);
    }
  }
}

// Define the custom element
customElements.define("countdown-element", Countdown);

var stateWasEmpty = true;
const personalizedCartImageBlobCache = new Map();
const personalizedCartImageResolvePromises = new Map();

function cartItemNeedsUploadSession(item) {
  const props = item?.properties || {};
  const isCoverOriginal =
    props._is_original === "true" &&
    (props._cover_photo_sku || props._cover_photo_size || props._upload_token);
  return (
    props._is_photo_print === "true" ||
    props._personalized ||
    props._personalized_album === "true" ||
    props._personalized === true ||
    isCoverOriginal
  );
}

function cartNeedsUploadSession(cartData) {
  return (cartData?.items || []).some(cartItemNeedsUploadSession);
}

function getOrderTimestampFromCartItems(items) {
  for (const item of items || []) {
    const props = item?.properties || {};
    if (props._order_timestamp) {
      return String(props._order_timestamp);
    }
  }
  return null;
}

async function recoverCartSessionTokens() {
  try {
    const response = await fetch(`/cart.js?t=${Date.now()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
      },
    });
    if (!response.ok) return { securityToken: null, timestamp: null };

    const cartData = await response.json();
    const securityToken = cartData.attributes?.private_cart_property || null;
    let timestamp = cartData.attributes?.private_cart_timestamp || null;

    if (!timestamp) {
      timestamp = getOrderTimestampFromCartItems(cartData.items);
    }

    if (securityToken) {
      localStorage.setItem("security_token", securityToken);
    }
    if (timestamp) {
      localStorage.setItem("upload_timestamp", timestamp);
    }

    return { securityToken, timestamp };
  } catch (error) {
    console.warn("Failed to recover cart session tokens:", error);
    return { securityToken: null, timestamp: null };
  }
}

async function fetchPersonalizedImageUrlFromCart(uploadToken) {
  if (!uploadToken) return "";
  try {
    const response = await fetch(`/cart.js?t=${Date.now()}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    if (!response.ok) return "";
    const cartData = await response.json();
    const matchedItem = (cartData.items || []).find(
      (item) => item?.properties?._upload_token === uploadToken
    );
    return matchedItem?.properties?._image_url || "";
  } catch (error) {
    console.warn("Failed to fetch personalized cart image by token:", error);
    return "";
  }
}

function isRemoteImageUrl(imageUrl) {
  return /^https?:\/\//i.test(String(imageUrl || ""));
}

async function fetchImageAsBlobUrl(imageUrl) {
  if (!imageUrl) return "";
  if (!isRemoteImageUrl(imageUrl)) return imageUrl;
  if (personalizedCartImageBlobCache.has(imageUrl)) {
    return personalizedCartImageBlobCache.get(imageUrl);
  }

  try {
    const headers = { "ngrok-skip-browser-warning": "true" };
    let securityToken = localStorage.getItem("security_token");
    let timestamp = localStorage.getItem("upload_timestamp");
    if (!securityToken || !timestamp) {
      const recovered = await recoverCartSessionTokens();
      securityToken = securityToken || recovered.securityToken;
      timestamp = timestamp || recovered.timestamp;
    }
    if (securityToken) headers.Authorization = `Bearer ${securityToken}`;
    if (timestamp) headers["x-upload-timestamp"] = timestamp;

    const response = await fetch(imageUrl, { method: "GET", headers });
    // Signed upload URLs can expire; return empty to trigger product-image fallback.
    if (!response.ok) return "";
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    personalizedCartImageBlobCache.set(imageUrl, blobUrl);
    return blobUrl;
  } catch (error) {
    console.warn("Failed to resolve personalized cart image URL:", error);
    return "";
  }
}

function getCartItemProductFallbackUrl(item, imageEl) {
  return (
    item.dataset.productImageUrl ||
    imageEl.getAttribute("data-original-src") ||
    imageEl.currentSrc ||
    imageEl.getAttribute("src") ||
    imageEl.getAttribute("data-src") ||
    ""
  );
}

function applyCartImageSource(imageEl, url) {
  if (!imageEl || !url) return;
  imageEl.src = url;
  imageEl.setAttribute("src", url);
  imageEl.removeAttribute("srcset");
  imageEl.removeAttribute("data-srcset");
  imageEl.removeAttribute("data-src");
}

async function resolvePersonalizedCartImage(uploadToken, fallbackUrl = "") {
  if (!uploadToken) return "";
  if (personalizedCartImageResolvePromises.has(uploadToken)) {
    return personalizedCartImageResolvePromises.get(uploadToken);
  }

  const promise = (async () => {
    let imageUrl = fallbackUrl;
    let source = fallbackUrl ? "liquid-fallback" : "none";

    if (!imageUrl) {
      imageUrl = await fetchPersonalizedImageUrlFromCart(uploadToken);
      if (imageUrl) source = "cart.js-by-token";
    }

    const resolvedUrl = await fetchImageAsBlobUrl(imageUrl);
    console.log("[personalized-cart-image] resolve", {
      uploadToken,
      source,
      imageUrl,
      resolvedUrl: resolvedUrl || imageUrl || "",
    });
    return resolvedUrl || imageUrl || "";
  })();

  personalizedCartImageResolvePromises.set(uploadToken, promise);
  try {
    return await promise;
  } finally {
    personalizedCartImageResolvePromises.delete(uploadToken);
  }
}

async function applyPersonalizedCartImages(rootElement = document) {
  const cartItems = rootElement.querySelectorAll(".cart-item[data-original='true']");
  if (!cartItems.length) return;

  for (const item of cartItems) {
    const uploadToken = item.dataset.token;
    const fallbackUrl = item.dataset.imageUrl || "";
    const imageEl = item.querySelector(".cart-item__image img");
    if (!imageEl) continue;
    const productFallbackUrl = getCartItemProductFallbackUrl(item, imageEl);
    if (productFallbackUrl && !imageEl.getAttribute("data-original-src")) {
      imageEl.setAttribute("data-original-src", productFallbackUrl);
    }

    let resolvedUrl = "";
    if (uploadToken) {
      resolvedUrl = await resolvePersonalizedCartImage(uploadToken, fallbackUrl);
    } else if (fallbackUrl) {
      resolvedUrl = await fetchImageAsBlobUrl(fallbackUrl);
      console.log("[personalized-cart-image] resolve", {
        uploadToken: null,
        source: "liquid-fallback-no-token",
        imageUrl: fallbackUrl,
        resolvedUrl: resolvedUrl || fallbackUrl || "",
      });
    }

    if (resolvedUrl) {
      imageEl.onerror = () => {
        const fallback = imageEl.getAttribute("data-original-src") || productFallbackUrl;
        if (fallback && imageEl.src !== fallback) {
          imageEl.onerror = null;
          applyCartImageSource(imageEl, fallback);
        }
      };
      applyCartImageSource(imageEl, resolvedUrl);
      imageEl.loading = "eager";
      imageEl.decoding = "sync";
      imageEl.fetchPriority = "high";
      console.log("[personalized-cart-image] apply", {
        uploadToken: uploadToken || null,
        target: ".cart-item__image img",
        src: resolvedUrl,
      });
    } else {
      if (productFallbackUrl) {
        applyCartImageSource(imageEl, productFallbackUrl);
      }
      console.log("[personalized-cart-image] apply:skipped", {
        uploadToken: uploadToken || null,
        fallbackUrl: fallbackUrl || null,
        productFallbackUrl: productFallbackUrl || null,
        reason: "no-resolved-url",
      });
    }
  }
}

function preloadImageUrl(url, timeoutMs = 1200) {
  return new Promise((resolve) => {
    if (!url) return resolve(false);
    const img = new Image();
    let settled = false;

    const done = (result) => {
      if (settled) return;
      settled = true;
      resolve(result);
    };

    const timer = setTimeout(() => done(false), timeoutMs);
    img.onload = () => {
      clearTimeout(timer);
      done(true);
    };
    img.onerror = () => {
      clearTimeout(timer);
      done(false);
    };
    img.decoding = "sync";
    img.fetchPriority = "high";
    img.src = url;
  });
}

async function preloadPersonalizedCartImages(rootElement = document) {
  const cartItems = rootElement.querySelectorAll(".cart-item[data-original='true']");
  if (!cartItems.length) return false;

  let hasPersonalizedImages = false;
  const preloadTasks = [];

  for (const item of cartItems) {
    const uploadToken = item.dataset.token;
    const fallbackUrl = item.dataset.imageUrl || "";
    const imageEl = item.querySelector(".cart-item__image img");
    if (!imageEl) continue;

    let resolvedUrl = "";
    if (uploadToken) {
      resolvedUrl = await resolvePersonalizedCartImage(uploadToken, fallbackUrl);
    } else if (fallbackUrl) {
      resolvedUrl = await fetchImageAsBlobUrl(fallbackUrl);
    }

    if (!resolvedUrl) continue;
    hasPersonalizedImages = true;
    imageEl.loading = "eager";
    imageEl.decoding = "sync";
    imageEl.fetchPriority = "high";
    preloadTasks.push(preloadImageUrl(resolvedUrl));
  }

  if (!hasPersonalizedImages) return false;
  await Promise.all(preloadTasks);
  return true;
}

class cartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.focusElement = false;
    this.imageCache = new Map(); // Add image cache to store blob URLs
    this.drawer = new Drawer(this.element, {
      onDrawerClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.alreadyEntered = false;
        bodyScrollLock.clearAllBodyScrollLocks();
        if (this.focusElement) {
          bodyScrollLock.enableBodyScroll(this.focusElement);
        }
      },
      onDrawerOpen: () => {
        this.isOpen = true;
        if (this.alreadyEntered == false) {
          this.onOpen();
        }
        this.alreadyEntered = true;
      },
    });
    this.loader = this.element.querySelector(".itemLoader");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;

    this.alreadyEntered = false;
    new AddToCart(this.element);

    this.bindEvents();
    applyPersonalizedCartImages(this.element);
  }

  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);

      document.addEventListener(
        "preview-cart:opened",
        this.openImagePreview.bind(this)
      );

      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".cart-item__quantity",
        this.updateItemQuantity.bind(this)
      );

      window.theme.listener = "true";
    }
  }

  onOpen() {
    document.documentElement.style.setProperty(
      "--cart-drawer__header-height",
      document.querySelector(".cart-drawer__header").offsetHeight + "px"
    );

    if (this.options["showRecommendations"] && this.alreadyEntered == false) {
      this.loadRecommendations();
    }

    this.changeMoneyFormatForPrinter();
  }

  async openImagePreview() {
    const completeUrl = event.detail.imageUrl;
    let securityToken = localStorage.getItem("security_token");
    let timestamp = localStorage.getItem("upload_timestamp");

    // Get popup elements
    const popup = document.querySelector('#personalization-cart__preview-modal');
    const img = popup.querySelector("#preview-image-cart");
    const loader = popup.querySelector(".itemLoader");

    try {
      // Clean up img element before each use
      img.onload = null; // Remove previous event listener
      img.src = ""; // Clear previous image
      img.style.display = "none"; // Hide while loading

      // Check cache first
      if (this.imageCache.has(completeUrl)) {
        const cachedImageUrl = this.imageCache.get(completeUrl);
        img.src = cachedImageUrl;
        img.style.display = "block";
        return;
      }

      // Only show loader for new fetches
      if (loader) {
        loader.classList.add("is-visible");
      }

      if (!securityToken || !timestamp) {
        const recovered = await recoverCartSessionTokens();
        securityToken = securityToken || recovered.securityToken;
        timestamp = timestamp || recovered.timestamp;
      }

      if (!securityToken) {
        throw new Error("Security token is missing.");
      }

      const fetchHeaders = {
        Authorization: `Bearer ${securityToken}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      };
      if (timestamp) {
        fetchHeaders["x-upload-timestamp"] = timestamp;
      }

      // Make GET request to fetch the image
      const response = await fetch(completeUrl, {
        method: "GET",
        headers: fetchHeaders,
        cache: "default"
      });

      if (!response.ok) {
        throw new Error("Failed to fetch the image.");
      }

      // Get the image as a Blob
      const imageBlob = await response.blob();
      const imageUrl = URL.createObjectURL(imageBlob);

      if (imageUrl) {
        // Cache the blob URL
        this.imageCache.set(completeUrl, imageUrl);

        // Set up image load event to hide loader when image is ready
        img.onload = () => {
          if (loader) {
            loader.classList.remove("is-visible");
          }
          img.style.display = "block";
        };

        // Set image source (this will trigger the load event)
        img.src = imageUrl;
      } else {
        throw new Error("Failed to retrieve image URL.");
      }
    } catch (error) {
      console.error("Error fetching the image:", error);

      // Hide loader on error
      if (loader) {
        loader.classList.remove("is-visible");
      }

      alert("An error occurred while fetching the image.");
    }
  }

  handleTransitionEnd(target) {
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    this.recommendationContainer.removeEventListener(
      "transitionend",
      this.transitionEndHandler
    );
  }

  async updateItemQuantity(event, target) {
    let token = null;
    event.preventDefault();
    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem.querySelector(".itemLoader");
    itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const payload = {
      id: target.getAttribute("data-line-id"),
      quantity: quantity,
    };

    // Check if this is an original product and update its connected customized item
    const isOriginal = cartItem.dataset.original === "true";

    // Resolve the paired hidden personalized line (if any) so both lines can be updated atomically
    let hiddenLineId = null;
    let hiddenItem = null;
    if (isOriginal && target.dataset.token) {
      const connectedItem = this.element.querySelector(`[data-personalized="true"][data-token="${target.dataset.token}"]`);
      if (connectedItem) {
        const lineIdElement = connectedItem.querySelector('[data-line-id]');
        if (lineIdElement) {
          hiddenLineId = lineIdElement.getAttribute('data-line-id');
          hiddenItem = connectedItem;
        }
      }
    }

    if (quantity === 0) {
      if (target.dataset.token) {
        token = target.dataset.token;
      }
      const id = cartItem.dataset.id;
      if (this.cartIds) {
        this.cartIds = this.cartIds.filter((item) => item !== id);
      }
      const nextItem = cartItem.nextElementSibling;
      const height = cartItem.offsetHeight;
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );

      setTimeout(() => {
        cartItem.remove();
        if (hiddenItem) hiddenItem.remove();

        if (!nextItem) {
          return;
        }
        nextItem.classList.add("repo--top");
        setTimeout(() => {
          nextItem.classList.remove("repo--top");
        }, 350);
      }, 350);
    }

    try {
      const updates = { [payload.id]: quantity };
      if (hiddenLineId) updates[hiddenLineId] = quantity;

      const response = await fetch(
        `${window.routes.localeRootUrl}/cart/update.js`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ updates }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      const hasPhotoPrint = data.items.some(
        (item) => item.properties && item.properties._is_photo_print === "true"
      );

      const hasPersonalized = data.items.some(
        (item) => item.properties && item.properties._personalized
      );

      if (
        !hasPhotoPrint &&
        !hasPersonalized &&
        data.attributes &&
        data.attributes.private_cart_property
      ) {
        await fetch(`${window.routes.localeRootUrl}/cart/update.js`, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            attributes: {
              private_cart_property: "",
              private_cart_timestamp: "",
              photo_print_order: null
            },
          }),
        });
      }

      if (token) {
        const size = target.dataset.size;
        apiService
          .deleteFiles(token, "/api/file/token-delete", size)
          .then((result) => console.log("Deletion result:", result))
          .catch((error) => console.error("Error deleting files:", error));
      }

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
      }
      if (quantity == 0 && data.item_count > 0) {
        stateWasEmpty = true;
        if (this.options.showRecommendations) {
          this.options["productId"] = data.items[0].product_id;
          this.renderCart(false, false, false, null, true);
          return;
        }
      }
      if (data.item_count > 0 && quantity > 0) {
        this.renderCart(target.getAttribute("data-id"), true);
      }
    } catch (error) {
      console.error("Failed to update item quantity:", error);
      // Optionally, show an error message to the user
    }
  }

  onProductAdded(event) {
    let details = event.detail || false;

    if (window.theme.cartCount === 0 && this.isOpen === true) {
      this.loader.classList.add("is-visible");
    }

    this.renderCart(false, false, true, details).then(async () => {
      // Wait a bit for section replacement, then eager preload personalized images before opening.
      await new Promise((resolve) => setTimeout(resolve, 220));
      const hasPreloadedPersonalizedImages = await preloadPersonalizedCartImages(this.element);
      if (hasPreloadedPersonalizedImages) {
        await new Promise((resolve) => setTimeout(resolve, 180));
      }

      if (this.element.hasAttribute("data-open-drawer")) {
        if (this.isOpen === false) {
          this.isOpen = true;
          this.onOpen();
          this.alreadyEntered = true;
          this.drawer.openDrawer();
        }
      }
    });
  }

  renderCart(
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {
    this.pageLoader.style.width = "90%";
    const _this = this;

    return fetch(`${window.routes.localeRootUrl}/?section_id=main-cart_drawer`, {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(async function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount
        );

        // Wait one paint frame for DOM replacement to complete
        await new Promise((resolve) => requestAnimationFrame(resolve));
        // Optional small delay if needed for slow DOM updates
        await new Promise((resolve) => setTimeout(resolve, 50));

        // // Reapply upload tokens and connected item links
        // const cartRoot = _this.element || document;
        // const originalItems = cartRoot.querySelectorAll("[data-original='true']");

        // for (const cartItem of originalItems) {
        //   const connectedProductId = cartItem.dataset.connectedProduct;
        //   if (!connectedProductId) continue;

        //   const connectedItem = cartRoot.querySelector(
        //     `[data-personalization-id="${connectedProductId}"]`
        //   );
        //   if (!connectedItem) continue;

        //   const uploadTokenElement = connectedItem.querySelector("[data-token]");
        //   if (!uploadTokenElement) continue;

        //   const uploadToken = uploadTokenElement.getAttribute("data-token");

        //   const updateButtons = cartItem.querySelectorAll(
        //     '[data-action="update-item-quantity"]'
        //   );
        //   const deleteButton = cartItem.querySelector(
        //     '[data-action="remove-item"]'
        //   );

        //   updateButtons.forEach((btn) => {
        //     btn.setAttribute("data-token", uploadToken);
        //   });

        //   if (deleteButton) {
        //     deleteButton.setAttribute("data-token", uploadToken);
        //   }

        // }
      });
    });
  }

  replaceContent(
    html,
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {
    // Prepare the page loader animation
    this.pageLoader.style.width = "100%";
    setTimeout(() => {
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";

      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);
    }, 100);

    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Extract options and update cart count
    const newOptions = JSON.parse(
      tempElement.querySelector("#cart-drawer").getAttribute("data-settings")
    );
    this.options = newOptions;

    if (!updateCount) {
      if (tempElement.querySelector("[data-ids]") != undefined) {
        this.cartIds = tempElement
          .querySelector("[data-ids]")
          .dataset.ids.split(",")
          .filter((item) => item !== "");
      }
    }

    const itemCount = newOptions.itemCount;
    window.theme.cartCount = parseInt(itemCount);

    if (itemCount > 0) {
      document.querySelector(".header__cart--populated").style.opacity = 1;
    } else {
      document.querySelector(".header__cart--populated").style.opacity = 0;
    }

    document.querySelectorAll(".header__cart-item-count").forEach((el) => {
      el.textContent = itemCount > 0 ? itemCount : "";
    });

    if (updateCount) {
      this.updateCartFooter(tempElement);
      return;
    }

    if (lineNumber && tempElement.querySelector(`#${lineNumber}`)) {
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && stateWasEmpty == false && lineNumber) {
      this.addContent(tempElement, lineNumber);
    } else {
      this.replaceCartContent(tempElement);
    }

    this.updateCartFooter(tempElement);

    this.element.dispatchEvent(
      new CustomEvent("cart:render", { bubbles: true })
    );

    this.changeMoneyFormatForPrinter();
    applyPersonalizedCartImages(this.element);

    if (itemCount == 0) {
      stateWasEmpty = true;
    } else {
      stateWasEmpty = false;
    }

    // Additional actions after a brief delay

    setTimeout(() => {
      if (
        this.options.showRecommendations &&
        !quantityChange &&
        this.isOpen == true
      ) {
        this.loadRecommendations();
      }

      if (this.element.hasAttribute("data-open-drawer")) {
        bodyScrollLock.clearAllBodyScrollLocks();
        this.focusElement = this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(
          this.focusElement,
          bodyScrollLockOptions
        );
      }
      this.drawer.maxHeight();
    }, 200);
  }

  changeMoneyFormatForPrinter() {
    const allItems = this.element.querySelectorAll(
      '[data-template="photo-printing"]'
    );
    if (allItems.length > 0) {
      allItems.forEach((item) => {
        const price = item.dataset.final;
        const moneyFormat = window.theme.moneyFormat.replace(
          /{{[^}]+}}/,
          "{{ amount }}"
        );
        const newPrice = Shopify.formatMoney(price, moneyFormat);
        const itemPrice =
          item.querySelector(".cart-item__price--discounted") || item;
        itemPrice.innerText = newPrice;
      });
    }
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = document.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__info `
    );
    const oldCartItemInfo = cartItemParent.querySelector(
      `#${lineNumber} .cart-item__info`
    );

    if (!cartItemParent) {
      this.element.querySelector(".itemLoader").classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent
        .querySelector(".cart-item__inner")
        .replaceChild(newCartItemInfo, oldCartItemInfo);
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, lineNumber) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__content").scrollTop = 0;
    }
    const itemToAdd = tempElement.querySelector(`#${lineNumber}`);
    const cartWrapper = this.element.querySelector(".cart-drawer__items");

    const firstItem = cartWrapper.firstElementChild;
    if (cartWrapper.querySelector(`#${lineNumber}`)) {
      this.updateCartItem(`${lineNumber}`, tempElement);
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      firstItem.classList.add("repo--bottom");
      this.loader.classList.remove("is-visible");
      setTimeout(() => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
        firstItem.classList.remove("repo--bottom");

        setTimeout(() => {
          itemToAdd.classList.remove("repo--adding");
        }, 350);
      }, 350);
    }
  }

  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 16;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }

  updateCartFooter(tempElement) {
    const itemCount = this.options.itemCount;

    if (itemCount > 0) {
      const footerParent = document.querySelector(".cart-drawer__footer");

      const newFooterTotals = tempElement.querySelector(
        ".cart_drawer__footer-totals"
      );
      const oldFooterTotals = document.querySelector(
        ".cart_drawer__footer-totals"
      );

      if (!footerParent || !newFooterTotals) return;
      if (oldFooterTotals) {
        footerParent.replaceChild(
          newFooterTotals,
          document.querySelector(".cart_drawer__footer-totals")
        );
      } else {
        footerParent.prepend(newFooterTotals);
      }

      const newShippingBar = tempElement.querySelector(
        ".cart-drawer__shipping-progress-bar"
      );
      if (newShippingBar) {
        const currentShippingBar = document.querySelector(
          ".cart-drawer__shipping-progress-bar"
        );
        if (currentShippingBar) {
          let percent = newShippingBar.dataset.percent;
          if (percent > 100) {
            percent = 100;
          }
          currentShippingBar.dataset.percent = percent;
          currentShippingBar.style.width = `${percent}%`;
          if (percent == 100) {
            currentShippingBar.classList.add("done");
            currentShippingBar.classList.remove("active");
          } else {
            currentShippingBar.classList.remove("done");
            currentShippingBar.classList.add("active");
          }
          this.element.querySelector(".cart-drawer__shipping-text").innerHTML =
            tempElement.querySelector(".cart-drawer__shipping-text").innerHTML;
        } else {
          const headerParent = this.element.querySelector(
            ".cart-drawer__header"
          );
          headerParent.appendChild(
            tempElement.querySelector(".cart-drawer__shipping")
          );
        }
      }
      this.drawer.maxHeight();
    } else {
      this.clearCartFooter(tempElement);
      stateWasEmpty = true;
    }
  }

  clearCartFooter(tempElement) {
    if (!tempElement.querySelector(".cart-drawer__wrapper")) return;
    if (document.querySelector(".cart-drawer__footer")) {
      document.querySelector(".cart-drawer__footer").classList.add("removing");
    }

    const wrapperParent = this.element.querySelector(".cart-drawer__wrapper");
    if (wrapperParent) {
      wrapperParent.innerHTML = tempElement.querySelector(
        ".cart-drawer__wrapper"
      ).innerHTML;
    }
  }

  replaceCartContent(tempElement) {
    const cartWrapperParent = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
      ".cart-drawer__content"
    ).scrollTop;

    cartWrapperParent.replaceChild(
      tempElement.querySelector(".cart-drawer__wrapper"),
      this.element.querySelector(".cart-drawer__wrapper")
    );
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__content").scrollTop =
      currentScrollPosition;
    this.loadRecommendations();
  }

  loadRecommendations() {
    // if (this.recommendationLoading == true || this.isOpen == false) return;
    this.recommendationLoading = true;
    let recommendationsContainer = this.element.querySelector(
      ".cart-drawer__recommendations"
    );

    if (!recommendationsContainer) return;
    const productId = this.options["productId"];
    const baseUrl = window.routes.localeRootUrl;
    let url;

    // Determine the URL based on whether a product ID is present
    if (!productId) {
      url = "?section_id=helper-recommendations";
    } else {
      let limit = this.element.getAttribute("product-limit");
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&l${limit}&intent=complementary`;
    }

    recommendationsContainer.classList.remove("transition--done");
    if (this.recommendationsOpen == true) {
      recommendationsContainer.classList.add("transition");
    }

    return fetch(url)
      .then((response) => response.text())
      .then((content) => {
        this.recommendationLoading = false;
        const container = document.createElement("div");
        container.innerHTML = content;

        let recommendedIds = null;
        if (container.querySelector(".cart-drawer__rec-item")) {
          recommendedIds = [
            ...container.querySelectorAll(".cart-drawer__rec-item"),
          ].map((item) => item.dataset.id);
        }
        if (!this.cartIds) {
          if (recommendationsContainer.dataset.ids) {
            this.cartIds = recommendationsContainer.dataset.ids
              .split(",")
              .filter((item) => item !== "");
          }
        }

        if (this.cartIds) {
          const hasCommonItem = this.cartIds.some((item) =>
            recommendedIds.includes(item)
          );
          if (hasCommonItem) {
            return;
          }
        }

        let recommendationsHTML = container.querySelector(
          ".cart-drawer__upsell"
        )?.innerHTML;

        if (recommendationsHTML) {
          recommendationsContainer.innerHTML = recommendationsHTML;
          this.initializeSwiper();
          new AddToCart(this.element);
          recommendationsContainer.classList.add("animatedContent");
          recommendationsContainer.setAttribute(
            "data-animation",
            "elementClipRevealFromRight"
          );
          new RevolutionAnimation(recommendationsContainer);
        }
      })
      .catch((error) => {
        console.error("Failed to load recommendations:", error);
      });
  }

  handleTransitionRec(target, container) {
    if (event.propertyName !== "transform") return;
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    container.classList.remove("transition");
    this.recommendationsOpen = false;
    this.el.removeEventListener("transitionend", this.transitionRecEnd);
  }

  initializeSwiper() {
    new Swiper(".helper-recomm-swiper", {
      slidesPerView: 2.21,
      spaceBetween: 8,
      resistanceRatio: 0,
      nested: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 2.25,
          spaceBetween: 8,
          navigation: {
            nextEl: ".cart-recommendations__swiper-button--next",
            prevEl: ".cart-recommendations__swiper-button--prev",
          },
        },
      },
    });
  }
}
customElements.define("cart-drawer", cartDrawer);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".featured-collection__swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (!this.carousel) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);


  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
    }

    this.createObserver();
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = responsive.getCurrentBreakpoint();

    let imageContainers = [];
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(this.element.querySelectorAll('.swiper-slide--first'));
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const currentSlide = this.carousel.swiperElement.slides[currentIndex];
      if (currentSlide.classList.contains('swiper-slide--first')) {
        imageContainers.push(this.carousel.swiperElement.slides[currentIndex]);
      }
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (breakpoint === 'pocket' || breakpoint === 'phone' || breakpoint === 'tablet') {
      imageToReveal = imageContainers[0].querySelector('.banner__image-wrapper--mobile .banner__image');
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1].querySelector('.banner__image-wrapper--desktop .banner__image');
      } else {
        imageToReveal = imageContainers[0].querySelector('.banner__image-wrapper--desktop .banner__image');
      }
    }

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === 'true') {
      return;
    }


    // Replace the image URL with a higher quality version.
    const replaceUrl = imageToReveal.dataset.src.replace('{width}x', 'width=2600');
    imageToReveal.src = replaceUrl;
    imageToReveal.dataset.loadedImage = 'true';
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector('[data-scrollable]');
    this.desktopMenu = this.element.querySelector(".desktop-menu");

    if (this.options.sticky) {
      this.toggleSticky();
    }


  }

  connectedCallback() {
    document.documentElement.style.setProperty(
      "--header-height",
      document.querySelector("#header").offsetHeight + "px"
    );

    this.toggleColor();
    this.updateVisibleHeight();
    this.calculateDropdownHeights();
    this.bindEvents();
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);
    // Update the height of .announcementBar with the visible height

    document.documentElement.style.setProperty('--header-dynamic-height', `${visibleHeight}px`);
  }

  calculateDropdownHeights() {
    this.dropdownHeights = [];


    this.element.querySelectorAll('.desktop-menu__dropdown').forEach(dropdown => {
      const id = dropdown.id;
      let dropdownHeight;

      // Create a clone to measure height without affecting visibility
      const dropdownClone = dropdown.cloneNode(true);
      dropdownClone.style.position = 'absolute';
      dropdownClone.style.visibility = 'hidden';
      dropdownClone.style.height = 'auto';
      dropdownClone.style.width = '100%';
      dropdownClone.style.pointerEvents = 'none';
      dropdownClone.setAttribute('aria-hidden', 'false');

      document.body.appendChild(dropdownClone);

      dropdownHeight = dropdownClone.offsetHeight;
      document.body.removeChild(dropdownClone);

      this.dropdownHeights.push({ id, height: dropdownHeight });
    });


  }



  toggleSticky() {
    this.element.parentElement.classList.add("header--sticky");
    this.element.parentElement.classList.remove("header--transparent");
  }

  bindEvents() {


    this.toggleColorListener = this.toggleColor.bind(this);

    scrollListener.addScrollListener(this, this.toggleColorListener);
    this.delegateBody.on("close:other", this.closeMenu.bind(this), true);

    window.addEventListener("DOMContentLoaded", this.calculateDropdownHeights.bind(this));
    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-hasMenu='true']",
      () => { clearTimeout(this._menuHoverTimeout); }, true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeOther.bind(this), true
    );


    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .header__menu-link",
      this.closeMenu.bind(this), true
    );

    responsive.addResizeListener(this, this.calculateDropdownHeights.bind(this));
    scrollListener.addScrollListener(this, this.updateVisibleHeight.bind(this));
    responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${document.querySelector('#header').offsetHeight}px`
    );
  }

  closeOther() {
    this.closeMenu(this);
  }

  openMenu(event, target) {
    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === 'mouseenter' && target !== event.target) {
      return;
    }

    const searchBar = document.querySelector('search-bar');
    const isSearchOpen = searchBar && searchBar.getAttribute('aria-expanded') === 'true';

    if (event.type === 'mouseenter' && isSearchOpen) {
      clearTimeout(this._menuHoverTimeout);
      this._menuHoverTimeout = setTimeout(() => this._doOpenMenu(target), 350);
      return;
    }

    this._doOpenMenu(target);
  }

  _doOpenMenu(target) {
    this.desktopMenu.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      this.desktopMenu.setAttribute('aria-expanded', 'true');
    });

    this.element.dispatchEvent(
      new CustomEvent("close:other", { bubbles: true })
    );
    this.desktopMenu.setAttribute('aria-hidden', 'false');

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);

    if (this.element.classList.contains('header--transparent')) {
      this.element.classList.remove('header--transparent');
      window.headerTransparent = true;
    }

    const allOpen = this.element.querySelectorAll('.desktop-menu__dropdown[aria-hidden="false"]');
    allOpen.forEach(function (item) {
      item.setAttribute("aria-hidden", "true");
    });

    const id = target.getAttribute('aria-controls');
    const targetElement = this.element.querySelector(`#desktop-menu__dropdown--${id}`);
    targetElement.setAttribute('aria-hidden', 'false');

    const dropdownData = this.dropdownHeights.find(item => item.id === targetElement.id);
    if (dropdownData) {
      this.desktopMenu.style.height = `${dropdownData.height}px`;
    }

    target.setAttribute('aria-expanded', 'true');

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter((child) => child !== target && child.getAttribute('aria-expanded') === 'true');
    siblings.forEach((item) => item.setAttribute('aria-expanded', 'false'));

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(this.scrollableElement, bodyScrollLockOptions);
  }


  closeMenu(event, target) {
    if (event.type === "mouseleave" && target !== event.target) { return; }


    const allOpen = this.element.querySelectorAll('.desktop-menu__dropdown[aria-hidden="false"]');
    if (!allOpen.length) return;
    this.desktopMenu.setAttribute('aria-expanded', 'false');
    this.desktopMenu.addEventListener('transitionend', () => {
      if (this.desktopMenu.getAttribute('aria-expanded') === 'false' && this.desktopMenu.getAttribute('aria-hidden') === "false") {
        this.desktopMenu.setAttribute('aria-hidden', 'true');
        allOpen.forEach(function (item) {
          item.setAttribute("aria-hidden", "true");
        });
      }
    }, { once: true });

    if (event.type !== "close:other") {
      bodyScrollLock.enableBodyScroll(this.scrollableElement);
    }
  }

  toggleColor() {
    const currentScrollTop = window.scrollY;

    if (currentScrollTop > 25) {
      this.element.classList.add('header--scrolled');
    } else {
      this.element.classList.remove('header--scrolled');
    }

    if (this.options.transparent) {
      if (currentScrollTop > 25 && this.options.sticky) {
        this.element.classList.remove("header--transparent");
      } else {
        this.element.classList.add("header--transparent");
      }
    }

    if (currentScrollTop >= this.lastScrollTop && this.options.sticky && currentScrollTop > 200) {
      this.element.closest('.shopify-section').classList.add('header--hide');
      setTimeout(() => {
        this.updateVisibleHeight();
      }, 300);

    } else {
      this.element.closest('.shopify-section').classList.remove('header--hide');
      setTimeout(() => {
        this.updateVisibleHeight();
      }, 300);
    }

    this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarMenu = new Drawer(this.element, {
      onDrawerClose: () => {
        this.hamburger.classList.remove("is-active");

        const openSubmenu = this.element.querySelector('.mobile-menu__grid[aria-expanded="true"]');
        openSubmenu.setAttribute('aria-hidden', 'true');
        openSubmenu.setAttribute('aria-expanded', 'false');
        bodyScrollLock.enableBodyScroll(openSubmenu);
        if (window.headerTransparent) {
          document.querySelector('.header').classList.add('header--transparent');
        }

      },
      onDrawerOpen: () => {
        this.hamburger.classList.add("is-active");
        if (document.querySelector('.header').classList.contains('header--transparent')) {
          document.querySelector('.header').classList.remove('header--transparent');
          window.headerTransparent = true;
        }

        this.element.querySelector('.mobile-menu__grid--level-one').setAttribute('aria-hidden', 'false');
        this.element.querySelector('.mobile-menu__grid--level-one').setAttribute('aria-expanded', 'true');

      }
    });

    this.hamburger = document.querySelector(".header__mobile-menu-button");

    this.bindEvents();
  }
  bindEvents() {
    document.addEventListener("sidebar-drawer:open", this.onDrawerListener);

    this.delegateElement.on("click", "[data-action='open-submenu'], [data-action='close-submenu']", this.toggleSubmenu.bind(this));
  }

  toggleSubmenu(event, target) {
    event.preventDefault();

    const id = target.getAttribute('aria-controls');
    const submenuToShow = this.element.querySelector(`#${id}`);
    const submenuToHide = this.element.querySelector('.mobile-menu__grid[aria-expanded="true"]');

    submenuToHide?.setAttribute('aria-expanded', 'false');
    submenuToHide?.classList.add('is-disabled');
    bodyScrollLock.enableBodyScroll(submenuToHide);
    submenuToHide?.addEventListener('transitionend', () => {
      submenuToHide.setAttribute('aria-hidden', 'true');
      submenuToHide.classList.remove('is-disabled');
    }, { once: true });

    submenuToShow?.setAttribute('aria-hidden', 'false');
    submenuToShow?.classList.add('is-disabled');
    submenuToShow?.addEventListener('transitionend', () => {

      submenuToShow.classList.remove('is-disabled');
    }, { once: true });

    requestAnimationFrame(() => {
      submenuToShow?.setAttribute('aria-expanded', 'true');
      bodyScrollLock.disableBodyScroll(submenuToShow);
    });


    submenuToShow.classList.contains('mobile-menu__grid--level-one') ? removeTrapFocus() : trapFocus(submenuToShow);
  }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {

      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";


    aspect_ratio = aspect_ratio.replace("/", ":");


    const payload = {
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: false,
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    if (host === "youtube" && this.options["youtube_native_controls"]) {
      payload.youtube = { ytControls: 2 };
    }

    if (aspect_ratio !== "auto") {
      payload.aspectRatio = aspect_ratio;
    }

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;

    if (aspect_ratio === "auto") {
      this.videoPlayer.on("loadedmetadata", function () {
        const width = this.videoWidth();
        const height = this.videoHeight();
        if (width && height) {
          const calculatedRatio = `${width}:${height}`;
          _this.videoPlayer.aspectRatio(calculatedRatio);

          // Set explicit height on VideoRatio container
          const videoRatioContainer = _this.element.closest('.videoWrapper');
          if (videoRatioContainer) {
            const containerWidth = videoRatioContainer.offsetWidth;
            const calculatedHeight = (containerWidth * height) / width;
            videoRatioContainer.style.height = `${calculatedHeight}px`;
          }
        }
      });
    }

    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }

      _this.bindCustomControls();
      _this.bindVideoRedirect();
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"] && !this.options["video_redirect_url"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == "html5") return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  bindVideoRedirect() {
    const url = this.options["video_redirect_url"];
    if (!url) return;

    this.delegateElement.on(
      "click",
      "[data-action='confirm-video-redirect']",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.__videoRedirectPendingUrl = url;
        const modal = document.getElementById("video-redirect-confirm-modal");
        if (modal && window.globalPopup) {
          window.globalPopup.openPopup(modal, false);
        }
      }
    );
  }

  bindCustomControls() {
    this.stateElement = this.element.querySelector(".section-video__state[data-action='toggle-state']");
    this.soundElement = this.element.querySelector("[data-action='toggle-sound']");

    if (!this.stateElement || !this.soundElement) return;

    this.delegateElement.on("click", "[data-action='toggle-state']", () => this.videoPlayer.paused() ? this.videoPlayer.play() : this.videoPlayer.pause());
    this.delegateElement.on("click", "[data-action='toggle-sound']", () => this.videoPlayer.muted() ? this.videoPlayer.muted(false) : this.videoPlayer.muted(true));

    this.videoPlayer.on("play", () => this.stateElement.setAttribute("aria-label", "playing"));
    this.videoPlayer.on("pause", () => this.stateElement.setAttribute("aria-label", "paused"));
    this.videoPlayer.on("volumechange", () => this.soundElement.setAttribute("aria-label", this.videoPlayer.muted() ? "muted" : "unmuted"));
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }
          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

var contentCache = {};
sessionStorage.setItem("elementaryLoad", "true");

class SearchComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new AddToCart(this)
  }
}

customElements.define("search-component", SearchComponent);
class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.carouselElement = this.element.querySelector(".product-module__main-swiper");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.starTemplateBlock = this.element.querySelector(".product-module__star-templates");
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");


    this.changeImageQuality();
    this.initSwiper();

    new AddToCart(this.element);
    if (this.options["enable_zoom"]) new RevolutionImageZoom(this.carouselElement, this.carousel);
    selectBoxes.forEach(selectbox => new RevolutionSelectbox(selectbox));
    this.element.querySelectorAll(".product-module__connected-items-swiper").forEach(swiper => new RevolutionSwiper(swiper));

    if (this.options["variant_image_id"] && this.options["show_variant_image_on_load"]) {
      this.updateImage();
    }

    if (this.options["sticky_atc"]) {
      this.stickyAtc = this.element.querySelector(".product-module__sticky-atc");
      this.mainAtc = this.element.querySelector(".product-module__product-atc-wrapper");
      this.footer = document.querySelector(".shopify-section-group-footer-group");
    }

    this.bindEvents();

  }

  connectedCallback() {
    this.notifyButtons = document.querySelectorAll(
      ".product-module__product-atc-notify"
    );
    this.notifyMeEnabled = document.querySelector("notify-me-popup");
    this.atcButtons = document.querySelectorAll(".product-module__product-atc");

    this.showNotifyMeButton(this.options["data_avaliable"]);
  }

  showNotifyMeButton(available) {
    if (!this.notifyButtons || !this.notifyMeEnabled) return;

    if (available) {
      this.notifyButtons.forEach((btn) => (btn.style.display = "none"));
      this.atcButtons.forEach((btn) => (btn.style.display = "block"));
    } else {
      this.notifyButtons.forEach((btn) => (btn.style.display = "block"));
      this.atcButtons.forEach((btn) => (btn.style.display = "none"));
    }
  }

  initSwiper() {
    if (this.options["slides_number"] > 1 && responsive.matchesBreakpoint("pocket") && !this.carousel) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    } else if (this.carousel) {
      this.carousel.destroy();
      this.carousel = null;
    }
  }

  bindEvents() {
    this.delegateElement.on("variant:changed", this.updateImage.bind(this));

    if (this.options["sticky_atc"]) {
      scrollListener.addScrollListener(this, this.showStickyAtc.bind(this));
      window.addEventListener("load", this.showStickyAtc.bind(this));
    }

    if (this.starTemplateBlock) {
      this.customizeStarReviews();
    }

    responsive.addBreakpointListener("tablet_and_up");
    this.delegateBody.on("breakpoint:tablet_and_up", this.initSwiper.bind(this));

    // Important for the reload without refresh functionality
    window.addEventListener("popstate", this.reloadPage.bind(this));
    window.addEventListener("DOMContentLoaded", this.reloadWithoutRefresh.bind(this));
    this.delegateElement.on("click", '[data-action="handle-reload"]', this.updateContentWithoutReload.bind(this));
  }

  customizeStarReviews() {
    const starRating = this.element.querySelector('.product-module__star-rating');
    const customStars = starRating ? starRating.querySelector('.product-module__custom-stars') : null;
    const templatesBlock = this.starTemplateBlock;

    if (!starRating || !customStars || !templatesBlock) {
      return;
    }

    const templates = {
      full: templatesBlock.querySelector('template[data-star-template="full"]'),
      half: templatesBlock.querySelector('template[data-star-template="half"]'),
      empty: templatesBlock.querySelector('template[data-star-template="empty"]'),
    };

    if (!templates.full || !templates.half || !templates.empty) {
      return;
    }

    const maxStars = 5;

    const appendClones = (template, count) => {
      for (let i = 0; i < count; i++) {
        customStars.appendChild(template.content.cloneNode(true));
      }
    };

    const ensureInfoRow = () => {
      let infoRow = starRating.querySelector('.product-module__star-info');
      if (!infoRow) {
        infoRow = document.createElement('div');
        infoRow.className = 'product-module__star-info u-t4';
        infoRow.innerHTML = '<span class="product-module__star-score"></span><span class="product-module__review-count"></span>';
        starRating.appendChild(infoRow);
      }
      return infoRow;
    };

    const updateInfoText = () => {
      const infoRow = ensureInfoRow();
      const scoreElement = starRating.querySelector('.yotpo-sr-bottom-line-score');
      const reviewsElement = starRating.querySelector('.yotpo-sr-bottom-line-text--right-panel');
      const scoreTarget = infoRow.querySelector('.product-module__star-score');
      const reviewTarget = infoRow.querySelector('.product-module__review-count');

      if (scoreElement && scoreTarget) {
        const scoreText = scoreElement.textContent.trim();
        scoreTarget.textContent = scoreText ? `${scoreText} / 5` : '';
      } else if (scoreTarget) {
        scoreTarget.textContent = '';
      }

      if (reviewsElement && reviewTarget) {
        reviewTarget.textContent = reviewsElement.textContent.trim();
      } else if (reviewTarget) {
        reviewTarget.textContent = '';
      }
    };

    const renderStars = (value) => {
      const normalized = Math.max(0, Math.min(maxStars, value));
      const solidStars = Math.floor(normalized);
      const remainder = normalized - solidStars;
      const hasHalf = remainder > 0 && normalized < maxStars;
      const emptyStars = maxStars - solidStars - (hasHalf ? 1 : 0);

      customStars.innerHTML = '';
      appendClones(templates.full, solidStars);
      appendClones(templates.half, hasHalf ? 1 : 0);
      appendClones(templates.empty, emptyStars);

      updateInfoText();
      starRating.style.opacity = '1';
    };

    const getRatingValue = () => {
      const scoreElement = starRating.querySelector('.yotpo-sr-bottom-line-score');
      if (!scoreElement) return null;

      const rawValue = scoreElement.textContent.trim().replace(',', '.');
      const parsed = parseFloat(rawValue);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const tryRender = () => {
      const ratingValue = getRatingValue();
      if (ratingValue === null) {
        return false;
      }
      renderStars(ratingValue);
      return true;
    };

    if (!tryRender()) {
      const observer = new MutationObserver(() => {
        if (tryRender()) {
          observer.disconnect();
        }
      });
      observer.observe(starRating, { childList: true, subtree: true });
    }
  }

  async reloadWithoutRefresh() {
    let pdpUrls = this.element.querySelectorAll(
      ".product-module__reload .product-module__selectbox-reload"
    );
    let urlsToFetch = Array.from(pdpUrls).map((link) => link.href);

    const fetchAndCacheContent = async (url) => {
      try {
        const response = await fetch(url);

        if (response.ok) {
          const htmlContent = await response.text();
          contentCache[url] = new DOMParser()
            .parseFromString(htmlContent, "text/html")
            .querySelector(".section__product-module");
        } else {
          console.error("Error fetching data. HTTP status:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    await Promise.all(urlsToFetch.map(fetchAndCacheContent));

    const preloadImages = (container) => {
      const images = container.querySelectorAll(
        ".product-module__product-slider-image--load-first"
      );
      images.forEach((img) => {
        const preloadedImage = new Image();
        preloadedImage.src = img.getAttribute("src");
      });
    };

    Object.values(contentCache).forEach(preloadImages);
  }

  reloadPage(e) {

    // Check if this is a back navigation (popstate triggered)
    window.location.reload();
  }

  updateContentWithoutReload(e) {
    e.preventDefault();
    const url = e.target.href;

    const htmlContent = contentCache[url];
    if (htmlContent) {


      document.title = htmlContent.querySelector('product-component').dataset.title;
      document.body.querySelector(`.section__product-module`).innerHTML =
        htmlContent.innerHTML;

      window.scrollTo(0, 0);

      if (typeof window['yotpo'] !== 'undefined') {
        window['yotpo'].initWidgets();
      } else {
        yotpoWidgetsContainer.initWidgets();
      }

      document.body.dispatchEvent(
        new CustomEvent("recommendations:reload", {
          bubbles: true,
          detail: htmlContent.querySelector('.product-module').dataset.productId
        })
      );

      Shopify.PaymentButton.init();
      // Optionally, update the URL in the address bar without a full page reload
      history.pushState(null, null, url);
    } else {
      window.location.href = url;
    }
  }

  showStickyAtc() {
    if (this.hideSticky) return;
    if (
      window.scrollY + window.innerHeight <
      this.footer.getBoundingClientRect().top + window.scrollY &&
      window.scrollY >
      this.mainAtc.getBoundingClientRect().bottom + window.scrollY
    ) {
      this.stickyAtc.setAttribute("aria-hidden", "false");
    } else {
      this.stickyAtc.setAttribute("aria-hidden", "true");
    }
  }

  updateImage(event) {
    if (event) {
      var imageID = event.detail.new_image;
    } else {
      var imageID = this.options["variant_image_id"];
    }

    var selector = "#product-module__image--" + imageID;
    var imageEl = this.element.querySelector(selector);

    if (imageEl) {
      this.carousel.selectCell(parseInt(imageEl.getAttribute("data-position")));
    }
  }

  changeImageQuality() {
    var imagesToReveal = null;
    imagesToReveal = this.element.querySelectorAll(
      ".product-module__product-slider-image--load-first"
    );

    imagesToReveal.forEach((image) => {
      if (image !== null) {
        const replaceUrl = image
          .getAttribute("data-src")
          .replace("{width}x", "2600x");
        image.src = replaceUrl;
      }
    });
  }
}
customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.templatePhotoPrint = this.element.querySelector('[data-template-pp]')?.dataset?.templatePp;

    this.atcButtons = document.querySelectorAll(".product-module__product-atc");
    this.notifyButtons = document.querySelectorAll(
      ".product-module__product-atc-notify"
    );

    this.price = this.element.querySelector('.product-module__product-main-prices');

    this.regularPrice = document.querySelector('.product-module__regular-price span');
    this.comparePrice = document.querySelector('.product-module__compare-price');

    this.notifyMeEnabled = document.querySelector("notify-me-popup");

    this.bindEvents();
    this.onVariantChange();
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    this.delegateElement.on(
      "change",
      ".product-module__selectbox-select, .product-module__selectbox-checkbox",
      this.onVariantChange.bind(this)
    );
  }

  showNotifyMeButton(available) {
    if (!this.notifyButtons || !this.notifyMeEnabled) return;

    if (available) {
      this.notifyButtons.forEach((btn) => (btn.style.display = "none"));
      this.atcButtons.forEach((btn) => (btn.style.display = "block"));
    } else {
      this.notifyButtons.forEach((btn) => (btn.style.display = "block"));
      this.atcButtons.forEach((btn) => (btn.style.display = "none"));
    }
  }

  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    window.current_variant = this.currentVariant;

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();


    this.updateNotifyMe();
  }



  updateOptions(notify) {
    if (!notify) {
      this.options = Array.from(
        this.querySelectorAll(
          ".product-module__selectbox-select, .product-module__selectbox-checkbox:checked"
        ),
        (select) => select.value
      );
    } else {
      const optionsString = event.detail.values;
      this.options = optionsString.split("||");
    }
  }

  areArraysEqual(arrayOne, arrayTwo) {
    if (arrayOne.length !== arrayTwo.length) {
      return false;
    }

    const sortedArrayOne = arrayOne.slice().sort();
    const sortedArrayTwo = arrayTwo.slice().sort();

    return sortedArrayOne.every(
      (value, index) => value === sortedArrayTwo[index]
    );
  }

  isSubset(subset, array) {
    return subset.every((element) => array.includes(element));
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      if (this.areArraysEqual(this.options, variant.options)) {
        return true;
      }

      return this.isSubset(this.options, variant.options);
    });

  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateNotifyMe() {
    if (!this.notifyMeEnabled) return;
    const itemToClick = document.querySelector(
      `.RevolutionSelectbox--Item[data-selectboxid="product-module__notify-selector"][data-id="${this.currentVariant.id}"]`
    );
    if (itemToClick) {
      itemToClick.click();
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}.product-module__product-form, #product-form-${this.productID}--sticky.product-module__product-form`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
    });
  }

  renderPrice() {
    let moneyFormat = window.theme.moneyFormat;
    if (this.templatePhotoPrint == 'true') {
      moneyFormat = window.theme.moneyFormat.replace(/{{[^}]+}}/, '{{ amount }}');
    }

    if (this.price) {
      let regularPrice = Shopify.formatMoney(
        this.currentVariant.price,
        moneyFormat
      );


      if (this.templatePhotoPrint == 'true') {
        regularPrice = window.photoPrinterStrings.per_photo.replace('{{ amount }}', regularPrice);
      }

      this.regularPrice.innerHTML = regularPrice;



      if (this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price) {
        let comparePrice = Shopify.formatMoney(
          this.currentVariant.compare_at_price,
          moneyFormat
        );

        if (this.templatePhotoPrint == 'true') {
          comparePrice = window.photoPrinterStrings.per_photo.replace('{{ amount }}', comparePrice);
        }

        this.comparePrice.innerHTML = comparePrice;
        this.comparePrice.style.display = "";
      } else {
        this.comparePrice.style.display = "none";
      }
    }
  }

  renderProductInfo() {
    this.renderPrice();
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".product-module__product-title";
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);

        if (source && destinations) {
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          });
        }

        const newPrice = html.querySelector('.product-price-lowest-money');
        const oldPrice = document.querySelector('.product-price-lowest-money');


        if (newPrice && oldPrice) {
          oldPrice.innerHTML = newPrice.innerHTML;
        }

        const quantityButton = document.querySelector(
          ".product-module__quantity-handler"
        );
        if (quantityButton) {
          const source = html.querySelector(
            ".product-module__quantity-handler"
          );
          if (source && quantityButton)
            quantityButton.innerHTML = source.innerHTML;
        }

        const newStockIndicator = html.querySelector('.product-module__stock-indicator');
        const oldStockIndicator = document.querySelector('.product-module__stock-indicator');
        if (newStockIndicator && oldStockIndicator) {
          oldStockIndicator.outerHTML = newStockIndicator.outerHTML;
        }

        const newAtcWrapper = html.querySelector('.product-module__product-atc-wrapper');
        const oldAtcWrapper = document.querySelector('.product-module__product-atc-wrapper');
        if (newAtcWrapper && oldAtcWrapper) {
          oldAtcWrapper.outerHTML = newAtcWrapper.outerHTML;
        }

        // Keep personalization modal ATC button in sync with the selected variant
        // (e.g. preorder button_text shown by the stock indicator).
        const newPersonalizationAtcWrapper = html.querySelector(
          '.personalization-modal__product-atc-wrapper'
        );
        const oldPersonalizationAtcWrapper = document.querySelector(
          '.personalization-modal__product-atc-wrapper'
        );
        if (newPersonalizationAtcWrapper && oldPersonalizationAtcWrapper) {
          oldPersonalizationAtcWrapper.outerHTML =
            newPersonalizationAtcWrapper.outerHTML;
        }
      });
  }

  toggleAddButton() {
    let quantity = "";
    const addButtonInner = document.querySelectorAll(".product-module__product-atc .ButtonText"),
      quantityEl = document.querySelector(".product-module__quantity-input");
    if (quantityEl) {
      quantity = quantityEl.value;
    }
    if (!quantity) quantity = 1;

    if (this.currentVariant.available && window.variantInfo.show_price) {
      const priceElement =
        "<span class='product-module__atc-price u-pb1'>|&nbsp;" +
        Shopify.formatMoney(this.currentVariant.price * quantity, window.theme.moneyFormat) +
        "</span>";
      addButtonInner.forEach((btn) => {
        btn.innerHTML = btn.innerHTML.replace(/<span class='product-module__atc-price.*$/s, '') + priceElement;
      });
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class Cache {
  constructor(maxCacheSize = 1) {
    this.maxCacheSize = maxCacheSize; // The maximum number of results to cache
    this.cache = []; // Array to hold cached results
  }

  addData(key, data) {
    // Check if the result is already cached
    const existingIndex = this.cache.findIndex((item) => item.key === key);

    if (existingIndex !== -1) {
      // If the result is already in the cache, remove it
      this.cache.splice(existingIndex, 1);
    }

    // Add the new result to the beginning of the cache
    this.cache.unshift({ key, data });

    // Remove the oldest cached result if cache exceeds the max size
    if (this.cache.length > this.maxCacheSize) {
      this.cache.pop();
    }
  }

  getCachedData(key) {
    // Find the cached result for the given key
    const cachedItem = this.cache.find((item) => item.key === key);
    return cachedItem ? cachedItem.data : null;
  }
}

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.queryCarouselElement = this.element.querySelector("#search__query-container.swiper");
    if (this.queryCarouselElement) this.queryCarousel = new RevolutionSwiper(this.queryCarouselElement);
    this.cachedResults = new Cache();
    this.cachedQueries = new Cache(3);

    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.searchResultsElement = this.element.querySelector(".search__dynamic-content");
    this.searchHeader = this.element.querySelector(".search__header");
    this.pageOverlayElement = document.getElementById("search__page-overlay");
    this.clearSearchButton = this.element.querySelector(".search__clear-button");
    this.queryList = this.element.querySelector(".search__queries");
    this.searchIcon = this.element.querySelector(".search__icon");

    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    new AddToCart(this.element);
    this.updateHeaderHeight();
    this.appendRecentSearches();
    this.initializeSwiper();
    this.bindEvents();
  }

  updateHeaderHeight() {
    if (!this.isOpen) {
      this.element.setAttribute("aria-hidden", false);
    }
    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchHeader.offsetHeight}px`
    );
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
    if (!this.isOpen) {
      this.element.setAttribute("aria-hidden", true);
    }
  }

  initializeSwiper() {
    this.carouselElement = this.searchResultsElement.querySelector(
      "[data-results] .swiper"
    );
    if (this.carouselElement) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }

  bindEvents() {
    this.onInputListener = debounce(this.onInput.bind(this), 450);
    this.handleSearchCloseBinder = this.handleSearchClose.bind(this);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateElement.on(
      "keydown",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    if (window.theme.showPredictiveSearches) {
      // Fast query search, not debounced
      this.delegateElement.on(
        "keydown",
        '[name="q"]',
        this.fastPredictiveSearches.bind(this)
      );
    }

    responsive.addResizeListener(this, this.updateHeaderHeight.bind(this));
    window.addEventListener("load", this.updateHeaderHeight.bind(this));

    this.searchInputElement.addEventListener("input", this.onInputListener);

    this.delegateBody.on("close:other", this.closeSearch.bind(this));
  }

  openSearch(e) {
    e.preventDefault();

    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    this.element.dispatchEvent(
      new CustomEvent("close:other", { bubbles: true })
    );

    this.element.removeEventListener('transitionend', this.handleSearchCloseBinder);

    this.element.setAttribute("aria-hidden", false);

    requestAnimationFrame(() =>
      this.element.setAttribute("aria-expanded", true)
    );


    this.pageOverlayElement.classList.add("is-visible");
    bodyScrollLock.disableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    this.setWidthOfSearchDropdown("open");

    // Focus on search input element after delay
    setTimeout(() => {
      if (this.searchInputElement) {
        this.searchInputElement.focus();
      }
    }, 200);

    // If header is transparent, remove it's transparency
    const header = document.querySelector(".header--transparent")
    if (header) {
      header.style.transition = "none";
      header.classList.remove("header--transparent");
      window.headerTransparent = true;
      setTimeout(() => {
        header.style.transition = "";
      }, 50);
    }

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }

    this.isOpen = true;
  }

  setWidthOfSearchDropdown(string) {
    if (string === "open") {
      if (responsive.matchesBreakpoint("lap_and_up")) {
        const scrollbarWidth = window
          .getComputedStyle(document.body)
          .getPropertyValue("padding-right");
        this.element.style.width = `calc(100% - ${scrollbarWidth})`;
      }
    } else {
      this.element.style.width = `100%`;
    }
  }

  closeSearch(e) {
    if (e) {
      e.preventDefault();
    }
    if (!this.isOpen) {
      return;
    }

    this.clearScrollLock = true;
    if (e && e.type === "close:other") {
      this.clearScrollLock = false;
    }

    // Hide search dropdown
    this.element.setAttribute("aria-expanded", false);
    this.element.addEventListener('transitionend', this.handleSearchCloseBinder);
    this.pageOverlayElement.classList.remove("is-visible");
    this.isOpen = false;
  }

  handleSearchClose(e) {
    if (e.propertyName != 'transform') return;
    this.element.setAttribute("aria-hidden", true);
    this.element.removeEventListener('transitionend', this.handleSearchCloseBinder);
    if (window.headerTransparent) {
      document.body
        .querySelector("#header")
        .classList.add("header--transparent");
    }

    this.resetSearch();
    if (this.clearScrollLock) {
      bodyScrollLock.enableBodyScroll(
        this.element.querySelector("[data-scrollable]"),
        bodyScrollLockOptions
      );
    }

    this.clearScrollLock = true;

    this.setWidthOfSearchDropdown();
  }

  async onInput(e) {
    this.lastInputValue = e.target.value;
    // Check whether user clicked on a query
    if (e.target.hasAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = e.target.getAttribute("data-value");
      this.searchInputElement.setAttribute("value", this.lastInputValue);
      this.searchInputElement.value = this.lastInputValue;
    } else if (this.lastInputValue === "") {
      this.resetSearch();
      return;
    }

    const cachedResults = this.cachedResults.getCachedData(this.lastInputValue);

    if (!cachedResults) {
      try {
        const response = await fetch(
          `${routes.predictive_search_url}?q=${encodeURIComponent(
            this.lastInputValue
          )}&resources[limit_scope]=each&section_id=search-predictive&resources[options][fields]=title,product_type,variants.title,body,tag,vendor,variants.sku`
        );

        if (!response.ok) {
          throw new Error(response.status);
        }

        const text = await response.text();
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-search-predictive");

        const searchResults = resultsMarkup.querySelector(".search__results");
        if (searchResults) {
          this.cachedResults.addData(this.lastInputValue, searchResults);
        }

        await this.appendResults(searchResults);
      } catch (error) {
        console.error("Failed to conduct a search.", error);
        if (error?.code === 20) {
          return;
        }

        throw error;
      }
    } else {
      await this.appendResults(cachedResults);
    }

    this.initializeSwiper();
    this.saveRecentSearch();
  }

  hideOrShowClearButton(string) {
    if (string === "show") {
      this.clearSearchButton.setAttribute("aria-hidden", "false");
      if (responsive.matchesBreakpoint("pocket")) {
        this.searchIcon.style.display = "none";
      }
    } else {
      this.clearSearchButton.setAttribute("aria-hidden", "true");
      if (responsive.matchesBreakpoint("pocket")) {
        this.searchIcon.style.display = "";
      }
    }
  }

  appendResults(searchResults) {
    this.clearSearchButton.setAttribute("aria-hidden", "false");
    return new Promise((resolve, reject) => {
      const oldResults =
        this.searchResultsElement.querySelector("[data-results]");

      oldResults.classList.remove("visible");
      oldResults.classList.add("hidden");

      // Remove empty containers before appending
      const otherContainer = searchResults.querySelector('.search__results-inner-container--other');
      if (otherContainer && otherContainer.children.length === 0) {
        otherContainer.remove();
      }

      searchResults.classList.remove("visible");
      searchResults.classList.add("hidden");

      const _this = this;

      if (this.element.getAttribute('aria-expanded') == "false") {
        const newResults =
          _this.searchResultsElement.querySelector("[data-results]");
        newResults.classList.add("visible");
        newResults.classList.remove("hidden");
      } else {
        oldResults.addEventListener("transitionend", function onFadeOutEnd() {
          oldResults.removeEventListener("transitionend", onFadeOutEnd);

          _this.searchResultsElement.replaceChild(searchResults, oldResults);

          const newResults =
            _this.searchResultsElement.querySelector("[data-results]");

          requestAnimationFrame(() => {
            newResults.classList.add("visible");
            newResults.classList.remove("hidden");
          });

          resolve();
        });
      }
    });
  }

  async resetSearch() {
    this.hideOrShowClearButton("hide");
    await this.appendResults(
      this.initialSearchLayout.querySelector(".search__results").cloneNode(true)
    );
    this.appendRecentSearches();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

    this.initializeSwiper();
    this.clearSearchButton.setAttribute("aria-hidden", "true");
    this.searchInputElement.focus();
  }

  saveRecentSearch() {
    if (!window.theme.showRecentSearches) return;

    if (this.lastInputValue.length > 3) {
      var searchTerms = JSON.parse(localStorage.getItem("searchTerms") || "[]");

      // If it doesn't already exist inside the array, push it top the beginning
      if (!searchTerms.includes(this.lastInputValue)) {
        searchTerms.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerms.slice(0, 4))
        );
      } catch (error) { }
    }
  }

  appendRecentSearches() {
    if (!window.theme.showRecentSearches) return;

    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let appendString = "";

    if (items.length > 0) {
      items.forEach((id) => {
        appendString =
          appendString +
          "<li role='option' tabindex='0' class='u-p3 search__query-recent swiper-slide hot-spot-mini' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      this.element.querySelector(".search__results-list--recent").innerHTML =
        appendString;
    } else {
      this.element.querySelector(".search__results--recent").style.display =
        "none";
    }
  }
}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

  }


  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".contact__block-button").removeAttribute("disabled");
    } else {
      this.element.querySelector(".contact__block-button").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    if (window.location.href.indexOf("customer_posted=true#popupForm") > -1) {
      this.options.delay = 0;
      this.openNewsletter();
    }
    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (localKey === "true") return;

    if (this.options.scroll_amount > 0) {
      this.scrollListenerInstance = scrollListener.addScrollListener(this, this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    if (this.scrollListenerInstance) {
      this.scrollListenerInstance.removeScrollListener();
    }

    setTimeout(() => {
      this.element.dispatchEvent(
        new CustomEvent("close:other", { bubbles: true })
      );

      this.element.setAttribute("aria-hidden", false);
      requestAnimationFrame(() => {
        this.element.setAttribute("aria-expanded", true);
      });

      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);
      this.delegateElement.on("click", '[data-action="close-modal"]', this.closeNewsletter);

      localStorage.setItem("popup-seen", true);
    }, 1000 * this.options.delay);
  }

  closeNewsletter = (e) => {
    e.preventDefault();

    this.element.setAttribute("aria-expanded", false);
    this.element.addEventListener("transitionend", () => {
      this.element.setAttribute("aria-hidden", true);
      bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
    }, { once: true }
    );

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);
    this.delegateElement.off("click", '[data-action="close-modal"]', this.closeNewsletter);
  };
}

customElements.define("newsletter-popup", NewsletterPopup);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.drawer = new Drawer(this.element.querySelector("#account__drawer"), {
      onDrawerOpen: () => {
        const inputToFocus = this.element.querySelector("[aria-visible='true'] .input-placeholder--first");
        if (inputToFocus) {
          inputToFocus.setAttribute("readonly", "readonly");
          inputToFocus.focus();
          inputToFocus.removeAttribute("readonly");
          this.element.querySelector(".account__drawer-closer").focus();
        }
      }
    });

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-tab"]',
      this.toggleTab.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-login"]',
      this.submitLogin.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-register"]',
      this.submitRegistration.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-recovery"]',
      this.toggleRecovery.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-recovery"]',
      this.accountRecover.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-login"]',
      this.accountInputSubmit.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-reg"]',
      this.accountInputSubmitReg.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-forgot-pass"]',
      this.accountInputSubmitForgot.bind(this)
    );
  }

  accountInputSubmit(e) {
    if (e.key === "Enter") this.submitLogin(e);
  }

  accountInputSubmitReg(e) {
    if (e.key === "Enter") this.submitRegistration(e);
  }

  accountInputSubmitForgot(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.accountRecover(e);
    }
  }

  async accountRecover(event) {
    event.preventDefault();
    event.target.closest("form").querySelector(".itemLoader")?.classList.add("is-visible");

    const recoverEndpoint = "/account/recover";
    const requestBody = {
      email: this.element.querySelector("#account__recover-email-input").value,
    };

    // If hCaptcha is present, append the info into the request body
    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody['h-captcha-response'] = captchaToken.response;
    }

    const responseText = await this.executeFetch(requestBody, recoverEndpoint, "password recovery");

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = responseText;

    if (responseText.indexOf("account__recover-email-error") !== -1) {
      this.element.querySelector("#account__recover-container .account__form-success-msg").innerHTML = "";
      this.element.querySelector("#account__recover-container .account__form-error").classList.add('active-error');
      this.element.querySelector("#account__recover-container .account__form-error").innerHTML = '<span class="AlertErrorInner pt-m u-p5">' + tempDiv.querySelector("#account__recover-email-error").innerHTML + "</span>";
    } else if (responseText.indexOf("account__form-success-msg") !== -1) {
      this.element.querySelector("#account__recover-container .account__form-error").innerHTML = "";
      this.element.querySelector("#account__recover-container .account__form-success-msg").innerHTML = '<span class="AlertErrorInner pt-m u-p5">' + tempDiv.querySelector("#account__form-success-msg").innerHTML + "</span>";
    }

    event.target.closest("form").querySelector(".itemLoader")?.classList.remove("is-visible");
  }

  async submitRegistration(event) {
    event.preventDefault();
    event.target.closest("form").querySelector(".itemLoader")?.classList.add("is-visible");

    const registrationEndpoint = "/account";
    const requestBody = {
      customer: {
        first_name: this.element.querySelector("#account__register-container #account__register-first-name-input").value,
        email: this.element.querySelector("#account__register-container #account__register-email-input").value,
        password: this.element.querySelector("#account__register-container #account__register-password-input").value
      },
    };

    // If hCaptcha is present, append the info into the request body
    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody['h-captcha-response'] = captchaToken.response;
    }

    const responseText = await this.executeFetch(requestBody, registrationEndpoint, "registration");

    if (responseText.indexOf("registerErrors") !== -1) {
      console.error("Error occurred during registration.");
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseText;

      const emailError = tempDiv.querySelector("#account__register-email-error");
      const passwordError = tempDiv.querySelector("#account__register-password-error");

      if (emailError) {
        this.element.querySelector("#account__register-email-error").classList.add('active-error');
        this.element.querySelector("#account__register-email-error").innerHTML = `<div class="AlertErrorInner u-p5 pt-m">${tempDiv.querySelector("#account__register-email-error").innerHTML}</div>`;
      }
      if (passwordError) {
        this.element.querySelector("#account__register-password-error").classList.add('active-error');
        this.element.querySelector("#account__register-password-error").innerHTML = `<div class="AlertErrorInner u-p5 pt-m">${tempDiv.querySelector("#account__register-password-error").innerHTML}</div>`;
      }
    } else {
      location.href = window.routes.account_url;
    }

    event.target.closest("form").querySelector(".itemLoader")?.classList.remove("is-visible");
  }

  async submitLogin(event) {
    event.preventDefault();
    event.target.closest("form").querySelector(".itemLoader")?.classList.add("is-visible");

    const loginEndpoint = "/account/login";
    const requestBody = {
      customer: {
        email: this.element.querySelector("#account__login-container #account__login-email-input").value,
        password: this.element.querySelector("#account__login-container #account__login-password-input").value
      }
    };

    // If hCaptcha is present, append the info into the request body
    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody['h-captcha-response'] = captchaToken.response;
    }

    const responseText = await this.executeFetch(requestBody, loginEndpoint, "login");

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = responseText;

    if (responseText.indexOf("loginError") !== -1) {
      console.error("Error occurred during login.");
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseText;

      this.element.querySelector("#account__login-container .account__form-error").classList.add('active-error');
      this.element.querySelector("#account__login-container .account__form-error").innerHTML = `<div class="AlertErrorInner u-p5 pb-m">${tempDiv.querySelector(".AlertError").innerHTML}</div>`;
    } else {
      location.href = window.routes.account_url;
    }

    event.target.closest("form").querySelector(".itemLoader")?.classList.remove("is-visible");
  }

  async executeFetch(requestBody, endpoint, process) {
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      return responseText;
    } catch (error) {
      console.error(`An error occurred during the ${process} process:`, error);
    }
  }

  toggleRecovery(e) {
    e.preventDefault();
    const id = e.target.dataset.id;

    if (id === "account__recover-container") {
      this.element
        .querySelector("#account__recover-container")
        .setAttribute("aria-visible", "true");
      this.element
        .querySelector("#account__signup-action")
        .setAttribute("aria-visible", "false");
    } else {
      this.element
        .querySelector("#account__recover-container")
        .setAttribute("aria-visible", "false");
      this.element
        .querySelector("#account__signup-action")
        .setAttribute("aria-visible", "true");

      if (e.target.dataset.open !== "") {
        this.element
          .querySelector(
            `[data-action="toggle-tab"][aria-controls="${e.target.dataset.open}"]`
          )
          ?.click();
      }
    }
  }

  toggleTab(e) {
    e.preventDefault();

    const id = e.target.getAttribute("aria-controls");
    const allTabs = this.element.querySelectorAll(
      '.account__action-tab[aria-expanded="true"]'
    );
    const allContent = this.element.querySelectorAll(
      '.account__action-container[aria-hidden="false"]'
    );

    allTabs.forEach((tab) => tab.setAttribute("aria-expanded", "false"));
    allContent.forEach((content) =>
      content.setAttribute("aria-hidden", "true")
    );


    e.target.setAttribute("aria-expanded", "true");

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute("aria-hidden", "false");
    }
  }
}

customElements.define("account-handler", AccountHandler);

let alreadyExits = false;
class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    if (!alreadyExits) {

      new Popup(this.element, true, false);

    }
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    if (sessionStorage.getItem('announcementBar') === 'hidden') {
      this.hide();
    }

    this.delegateElement = new Delegate(this.element);
    this.announcementItems = this.element.querySelectorAll('.announcement-bar__item');
    this.index = 1;

    this.bindEvents();
    this.startAnimating();
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="ann-bar-close"]', this.hide.bind(this));

    scrollListener.addScrollListener(this, this.updateVisibleHeight.bind(this));
    responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));
  }

  hide() {
    sessionStorage.setItem('announcementBar', 'hidden');
    this.element.remove();
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    let visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    visibleHeight = Math.max(visibleHeight, 0);

    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }

  startAnimating() {
    if (this.element.dataset.enableAnimation === "true" && this.announcementItems.length > 1) {
      window.addEventListener("load", () => {
        setInterval(() => this.animate(), this.element.dataset.cycleSpeed);
      });
    }
  }

  animate() {
    const currentItem = this.announcementItems[this.index];
    requestAnimationFrame(() => {
      currentItem.classList.add('slide-up');
      if (currentItem.previousElementSibling) {
        currentItem.previousElementSibling.classList.add('slide-out');
      } else {
        this.announcementItems[this.announcementItems.length - 1].classList.add('slide-out');
      }
    })

    if (this.index === 0) {
      this.announcementItems[0].style.zIndex = 3;
    } else {
      this.announcementItems[0].style.zIndex = '';
    }

    currentItem.addEventListener('animationend', () => {
      if (currentItem.previousElementSibling) {
        currentItem.previousElementSibling.classList.remove('slide-up');
        currentItem.previousElementSibling.classList.remove('slide-out');
      } else {
        this.announcementItems[this.announcementItems.length - 1].classList.remove('slide-up');
        this.announcementItems[this.announcementItems.length - 1].classList.remove('slide-out');
      }
    }, { once: true });

    this.index = (this.index + 1) % this.announcementItems.length;
  }
}
customElements.define("announcement-bar", AnimatedAnnouncementBar);

class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateBody = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
    new RevolutionSelectbox(this.element.querySelector('.RevolutionSelectbox'));

    this.containerPopup = document.querySelector("#modal-country");
    this.selectString = this.element.querySelector(".country-selector__select-string");
    this.selectboxTitle = this.element.querySelector(".RevolutionSelectbox--Title");

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on("change:countrySelector", this.updateLanguageOptions.bind(this));
    this.delegateElement.on('keydown', '[data-action="select-language"]', this.selectLanguage.bind(this));
    this.delegateElement.on('click', '[data-action="reset-localization"]', this.resetLocalization.bind(this));
  }

  resetLocalization(e) {
    e.preventDefault();


    this.element.querySelector(`.RevolutionSelectbox--Item[data-value="${this.element.dataset.defaultMarket}"]`).click();

    this.selectboxTitle.innerHTML = '';
    const clonedString = this.selectString.cloneNode(true)
    clonedString.style.display = '';
    this.selectboxTitle.appendChild(clonedString);

    this.element.querySelector(`.country-selector__language-input[data-value="${this.element.dataset.defaultLanguage}"]`).click();


  }

  selectLanguage(e, target) {
    if (e.key === 'Enter') {
      target.previousElementSibling.checked = true;
    }
  }

  updateLanguageOptions(e) {
    const languagesJSON = e.detail.languages;
    const languages = JSON.parse(languagesJSON);

    const container = this.element.querySelector(".country-selector__language-input-list");

    container.innerHTML = "";

    const template = this.element.querySelector("#country-selector__language-template");

    languages.forEach((language, index) => {
      const templateClone = template.content.cloneNode(true);

      const inputElement = templateClone.querySelector("input");
      const labelElement = templateClone.querySelector("label");

      inputElement.setAttribute("id", inputElement.getAttribute("id").replace("[id]", language.iso));
      inputElement.setAttribute("value", inputElement.getAttribute("value").replace("[id]", language.iso));
      inputElement.setAttribute("data-value", inputElement.getAttribute("data-value").replace("[id]", language.iso));
      labelElement.setAttribute("for", labelElement.getAttribute("for").replace("[id]", language.iso));

      if (index === 0) {
        inputElement.setAttribute("checked", "checked");
      }

      if (languages.length < 2) {
        templateClone.querySelector(".country-selector__circle")?.remove();
      }

      labelElement.innerHTML += language.name;

      container.appendChild(templateClone);
    });
  }
}
customElements.define("localization-modal", LocalizationModal);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    document.documentElement.style.setProperty(
      "--footer-dynamic-height",
      this.element.offsetHeight + "px"
    );
    window.addEventListener("load", () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.element.offsetHeight + "px"
      );
      document.documentElement.style.setProperty(
        '--footer-height',
        document.querySelector('footer-component').offsetHeight + 'px'
      );
    });
    responsive.addResizeListener(this, () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.element.offsetHeight + "px"
      );
    });
  }
}
customElements.define("footer-component", FooterComponent);



class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;



    this.delegateBody = new Delegate(document.body);
    new RevolutionSwiper(this.querySelector(".product-recommendations__swiper"));
    new AddToCart(this.element)



  }

  connectedCallback() {
    this.delegateBody.on('recommendations:reload', this.reloadRecommendations.bind(this));
    this.loadRecommendations(this.dataset.url);
  }

  reloadRecommendations(e) {
    const productId = e.detail;
    const url = this.dataset.urlTemplate.replace("PRODUCT_ID", productId);
    this.loadRecommendations(url);
  }

  async loadRecommendations(url) {
    try {
      const response = await fetch(url);
      const text = await response.text();

      const html = document.createElement("div");
      html.innerHTML = text;

      const recommendations = html.querySelector("product-recommendations");

      recommendations.querySelectorAll('[data-animation-placeholder]').forEach(element => {
        const animationValue = element.getAttribute('data-animation-placeholder');
        element.setAttribute('data-animation', animationValue);
        element.removeAttribute('data-animation-placeholder');
      });

      const newSwiper = recommendations.querySelector(".product-recommendations__swiper");
      const oldSwiper = this.element.querySelector(".product-recommendations__swiper");

      if (recommendations && recommendations.innerHTML.trim().length) {
        oldSwiper.parentElement.replaceChild(newSwiper, oldSwiper);
        new RevolutionSwiper(newSwiper);
      }
    } catch (e) {
      console.error(e);
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);


class InfiniteScroll {
  constructor(container, restoreState) {
    this.containerSelector = container;
    this.treshold = 650;
    this.handleScrollListener = this.handleScroll.bind(this);
    this.domDelegate = new Delegate(document.body);

    if (restoreState == true && sessionStorage.getItem('pageNum')) {
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {

    this.listenerBinder = this.addUserScrollListener.bind(this);

    this.domDelegate.on(
      "click",
      '[data-action="load"]',
      this.listenerBinder
    );
  }

  initialize() {
    document.addEventListener("scroll", this.handleScrollListener);
  }

  addUserScrollListener(e) {

    e.preventDefault();

    this.handleClick();
    this.initialize();
    this.domDelegate.off(
      "click",
      this.listenerBinder
    );


  }

  handleScroll() {

    this.paginationElement = document.querySelector('#infiniteScroll');
    if (!this.paginationElement) return;
    const top = this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom = this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector('a');

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  handleClick() {
    event.preventDefault();

    event.target.closest('a').setAttribute('disabled', 'true');
    if (window.location.href.includes('/collections/'))
      sessionStorage.setItem('loadMoreClicked', 'true');
    this.paginationElement = document.querySelector('#infiniteScroll');
    if (!this.paginationElement) return;

    this.nextPageLinkElement = this.paginationElement.querySelector('a');

    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;

      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  destroy() {
    // Remove the event listener when the instance is no longer needed
    document.removeEventListener("scroll", this.handleScrollListener);
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];

    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem('pageNum'));
      for (let i = 2; i <= limit; i++) {
        let url;


        // Build the URL based on the condition
        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(fetch(url, {
          credentials: "same-origin",
          method: "GET",
        }));
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }));
    }

    return promises;
  }


  async renderData(promises, restoreContent) {
    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(responses.map(response => response.text()));
      let isLastPromise = false;
      contents.forEach((content, index) => {

        isLastPromise = index === contents.length - 1;



        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error('Error fetching or parsing data:', error);
    }
  }


  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const contentToAdd = doc.querySelector(this.containerSelector);


    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement = document.querySelector('#infiniteScroll');
    if (this.paginationElement) {
      this.paginationElement.remove();
    }

    this.mainContainer.insertAdjacentHTML('beforeend', contentToAdd.innerHTML);
    if (window.theme.enableAnimations) {
      new RevolutionAnimation(this.mainContainer);
    }
    this.paginationElement = document.querySelector('#infiniteScroll');
    if (lastPromise) {
      this.initialize();
    }

    if (lastPromise && restoreContent) {
      this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );

    requestAnimationFrame(() => {
      document.body.dispatchEvent(
        new CustomEvent("favorites:retoggle", {
        })
      );
    });

  }


  restoreScroll() {
    const selector = `${this.containerSelector} [data-id='${sessionStorage.getItem('clickedProductId')}']`;
    const targetElement = document.querySelector(selector);
    if (targetElement) {
      targetElement.scrollIntoView({

        behavior: 'smooth', // You can use 'auto' for instant scrolling
        block: 'end',     // You can use 'center' or 'end' for different alignments
      });
    }


  }
}


class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.dropdownContent = this.element.querySelector('.collection-active-items-grid.not_desktop');

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-collections-tabs"]',
      this.toggleCollectionBtn.bind(this)
    );
  }

  toggleCollectionBtn(e) {

    const isExpanded = this.dropdownContent.getAttribute('aria-expanded') === 'true';

    // Toggle aria-expanded attribute
    this.dropdownContent.setAttribute('aria-expanded', !isExpanded);

    if (e.target.getAttribute('aria-expanded') === 'false') {
      e.target.setAttribute('aria-expanded', true)
    } else {
      e.target.setAttribute('aria-expanded', false)
    }
  }


}
customElements.define("collection-tabs", CollectionTabs);




class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.allNotifications = this.element.querySelectorAll(".product-module__notify-action");

    this.bindEvents();
  }

  bindEvents() {
    this.onClickOutsideListener = this.closeNotifyMe.bind(this);

    this.delegateBody.on(
      "click",
      '[data-action="notify-open"]',
      this.openNotifyMe.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="subscribe"]',
      this.handleSubscribe.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="notify-close"]',
      this.closeNotifyMe.bind(this)
    );
    this.delegateElement.on(
      "keydown",
      this.handleSubscribe.bind(this)
    );
  }

  async handleSubscribe(e) {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }

    const email = this.element.querySelector('[name="notify_email"]').value;

    if (email !== "" && email.includes("@")) {
      const variantId = document.querySelector('form[data-product-form] [name="id"]').value;

      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": email,
                }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": `$shopify:::$default:::${variantId}`
              }
            }
          }
        }
      }

      const requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-06-15"
        },
        body: JSON.stringify(payload),
      };

      const endpoint = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.element.dataset.key}`;

      try {
        const response = await fetch(endpoint, requestOptions);

        if (response.status === 200 || response.status === 202) {
          this.showNotification("success");
        } else {
          this.showNotification("error");
        }
      } catch (error) {
        this.showNotification("error");
      }
    } else {
      this.showNotification("email-error");
    }
  }

  clearNotifications() {
    this.allNotifications.forEach((el) =>
      el.setAttribute("aria-hidden", "true")
    );
  }

  showNotification(string) {
    this.clearNotifications();

    let activeNotification;
    switch (string) {
      case "success":
        activeNotification = this.element.querySelector(".product-module__notify-action--success");
        break;
      case "email-error":
        activeNotification = this.element.querySelector(".product-module__notify-action--email-error");
        break;
      default:
        activeNotification = this.element.querySelector(".product-module__notify-action--error");
        break;
    }

    activeNotification.setAttribute("aria-hidden", "false");
  }

  openNotifyMe(e) {
    e.preventDefault();
    this.element.setAttribute("aria-hidden", "false");
    trapFocus(this.element);

    this.pageOverlayElement.classList.add("is-visible");
    bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

    this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);
  }

  closeNotifyMe(e) {
    this.element.setAttribute("aria-hidden", "true");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );

    // Remove scrolllock and clear notifications after the popup disappears so there are no visible layout shifts
    this.element.addEventListener(
      "transitionend",
      () => {
        if (e.target.closest('[data-action="notify-close"]')) {
          setTimeout(() => {
            bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
            this.clearNotifications();
          }, 50);
        } else {
          bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
          this.clearNotifications();
        }
      },
      { once: true }
    );
  }
}

customElements.define("notify-me-popup", NotifyMe);

class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.favoritesDrawer = new Drawer(this.element, {
      onDrawerClose: () => {
        this.open = false;
        this.previousLocalStorageValue = localStorage.getItem("productFavorites");
      },
      onDrawerOpen: () => {
        if (this.previousLocalStorageValue !== localStorage.getItem("productFavorites")) {
          this.rerenderFavorites();
        }
        this.open = true;
      }
    });

    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.favPopulated = document.querySelectorAll(".header__favorites--populated");
    this.contentElement = document.querySelector(".favorites__content");
    this.loader = this.element.querySelector(".spinningLoader");

    this.previousLocalStorageValue = localStorage.getItem("productFavorites");

    this.rerenderFavorites();
    this.updateFavoritesAcrossSite();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="toggle-favorites"]',
      this.toggleFavorite.bind(this)
    );

    this.delegateBody.on(
      "keydown",
      '[data-action="toggle-favorites"]',
      this.toggleFavorite.bind(this)
    );
  }

  toggleFavorite(e) {
    if (e.key && e.key != "Enter") {
      return;
    }

    e.preventDefault();

    let items = this.getFavorites();
    const productId = e.target.parentElement.getAttribute("data-id") || e.target.getAttribute("data-id");

    if (!productId) {
      return;
    }

    const existingItemIndex = items.findIndex(id => id === productId);

    if (existingItemIndex === -1) {
      items.unshift(productId);
    } else {
      items = items.filter(id => id !== productId);
      // If favorites drawer is open, remove the favorite without having to rerender the whole drawer
      if (this.open) this.removeSingleFavorite(productId);
    }

    this.saveFavorites(items);

    // If all items are removed or the favorites drawer is open and a favorite is added, rerender the drawer
    if (items.length === 0 || (existingItemIndex === -1 && this.open)) {
      this.rerenderFavorites(true);
    }
  }

  removeSingleFavorite(productId) {
    const productCardToRemove = this.contentElement.querySelector(`#product-card__${productId}`);
    if (productCardToRemove) {
      productCardToRemove.classList.add('removing');
      productCardToRemove.addEventListener('transitionend', () => {
        setTimeout(() => {
          productCardToRemove.parentElement.remove();
        }, 150);
      }, { once: true });
    }
  }

  updateFavoritesAcrossSite() {
    var items = this.getFavorites();
    var favorites = [
      ...document.querySelectorAll('[data-action="toggle-favorites"]'),
    ];

    if (items.length > 0) {

      this.favPopulated.forEach((item) => {
        item.style.opacity = "1";
      })
    } else {
      this.favPopulated.forEach((item) => {
        item.style.opacity = "0";
      })
    }

    favorites.forEach(function (item) {
      var state = item.getAttribute("state");
      var myID = item.getAttribute("data-id");
      var exists = items.some(id => id === myID);
      if (state == "not-active" && exists) {
        item.querySelector(".solid-favorite").style.display = "flex";
        item.querySelector(".empty-favorite").style.display = "none";
        item.setAttribute("state", "active");
      } else if (!exists) {
        item.querySelector(".solid-favorite").style.display = "none";
        item.querySelector(".empty-favorite").style.display = "flex";
        item.setAttribute("state", "not-active");
      }
    });
  }

  saveFavorites(items) {
    localStorage.setItem("productFavorites", JSON.stringify(items.slice(0, 50)));
    this.updateFavoritesAcrossSite();
  }

  getFavorites() {
    return JSON.parse(localStorage.getItem("productFavorites") || "[]").filter((item) => item.id !== null);
  }

  hideLoader(loader) {
    if (!loader) this.contentElement.style.opacity = "1";
    this.loader.classList.remove("is-visible");
  }

  async rerenderFavorites(loader) {
    if (loader) this.loader.classList.add("is-visible");
    else this.contentElement.style.opacity = "0";

    const queryStrings = this.getSearchQueryStrings();
    if (queryStrings.length === 0) {
      try {
        const response = await fetch("/?section_id=main-favorites_drawer");
        const html = await response.text();
        await this.appendContent(html, true);
        this.hideLoader(loader);
      } catch (error) {
        console.error("Error fetching main favorites section:", error);
      }
      return;
    }

    try {
      const promises = queryStrings.map((string) =>
        fetch(`${window.routes.localeRootUrl}/search?view=favorites&type=product&q=${string}`,
          {
            credentials: "same-origin",
            method: "GET",
          }
        )
      );

      let first = true;
      for (const promise of promises) {
        const response = await promise;
        const html = await response.text();
        this.appendContent(html, false, first);
        this.hideLoader(loader);
        first = false;
      }
    } catch (error) {
      console.error("Error fetching favorites:", error);
    }
  }

  async appendContent(html, reset, first) {
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    if (reset) {
      tempElement = tempElement.querySelector(".favorites__content");
      if (!tempElement) return;
      this.contentElement.innerHTML = tempElement.innerHTML;
      await this.loadRecommendations();
    } else {
      tempElement = tempElement.querySelector(".favorites__grid");
      if (first) {
        this.contentElement.innerHTML = "";
        this.contentElement.innerHTML = this.contentElement.innerHTML + tempElement.outerHTML;
      } else {
        var favoritesGrid = this.contentElement.querySelector(".favorites__grid");
        favoritesGrid.innerHTML = favoritesGrid.innerHTML + tempElement.innerHTML;
      }
    }

    if (window.theme.enableAnimations) {
      new RevolutionAnimation(this.element);
    }

    this.updateFavoritesAcrossSite();
    new AddToCart(this.element);
  }

  // Get search query strings for fetching the favorites over API, groups items in buckets of 10 because of the API limit
  getSearchQueryStrings() {
    const items = this.getFavorites();
    const bucketSize = 10;

    const idBuckets = Array.from({ length: Math.ceil(items.length / bucketSize) }, (_, i) =>
      items.slice(i * bucketSize, (i + 1) * bucketSize).map(id => `id:${id}`).join(" OR ")
    );

    return idBuckets;
  }

  async loadRecommendations() {
    if (!this.options["showRecommendations"]) return;

    if (this.options["productId"] == "") {
      var url = "?section_id=helper-recommendations_favorites";
    } else {
      var url = window.routes.localeRootUrl + "/recommendations/products?section_id=helper-recommendations_favorites&product_id=" + this.options["productId"] + "&limit=10";
    }

    try {
      const response = await fetch(url);
      const html = await response.text();

      const tempElement = document.createElement("div");

      if (html) {
        tempElement.innerHTML = html;

        const newSwiperWrapper = tempElement.querySelector(".helper-recomm-swiper .swiper-wrapper") || tempElement.querySelector(".favorites__recommendations-swiper .swiper-wrapper");
        const currentSwiperWrapper = this.element.querySelector(".favorites__recommendations-swiper .swiper-wrapper");

        if (currentSwiperWrapper) {
          currentSwiperWrapper.parentElement.replaceChild(newSwiperWrapper, currentSwiperWrapper);
        }

        this.initSwiper()
        if (window.theme.enableAnimations) {
          new RevolutionAnimation(this.element);
        }
      }
    } catch (error) {
      console.error(
        "Error fetching and loading recommendations for favorites:", error
      );
    }
  }

  initSwiper() {
    new Swiper(".favorites__recommendations-swiper", {
      slidesPerView: 2.21,
      spaceBetween: 8,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        1025: {
          slidesPerView: 2.25,
          spaceBetween: 8,
          navigation: {
            nextEl: ".favorites__swiper-button-next",
            prevEl: ".favorites__swiper-button-prev",
          },
        },
      },
    });
  }
}
customElements.define("favorites-drawer", FavoritesDrawer);


class CollectionShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    //break cases
    if (this.options["swiper_info"] === 'no-swiper' ||
      (this.options["swiper_info"] === 'only-mobile-swiper' && new Responsive().matchesBreakpoint("lap_and_up")) ||
      (this.options["swiper_info"] === 'only-desktop-swiper' && new Responsive().matchesBreakpoint("pocket")))
      return;



    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);


  }


}
customElements.define("collection-showcase", CollectionShowcase);

class termsSection extends HTMLElement {
  constructor() {
    super();

    // Initialize elements and delegates
    this.element = this;
    if (responsive.matchesBreakpoint("pocket")) {
      this.carousel = new RevolutionSwiper(
        this.element.querySelector("[data-swiper-settings]")
      );
    }

  }




}

customElements.define("section-terms", termsSection);


class USPSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (new Responsive().matchesBreakpoint("pocket")) {
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }



}
customElements.define("usp-section", USPSection);

class faqSection extends HTMLElement {
  constructor() {
    super();

    // Initialize elements and delegates
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.searchInput = this.element.querySelector(".faq__search-input");
    this.termsBlocks = document.querySelectorAll(".faq__block");
    this.noResultsElement = document.querySelector("#faq__results--none");

    // Initialize the Swiper carousel
    if (responsive.matchesBreakpoint("pocket")) {
      this.carousel = new RevolutionSwiper(
        this.element.querySelector("[data-swiper-settings]")
      );
    }
    // Bind events to the elements
    this.bindEvents();
    this.handleScroll();
  }

  // Method to bind events
  bindEvents() {
    this.delegateElement.on("click", '[data-action="handle-click"]', this.handleClick.bind(this));
    this.handleScrollListener = this.handleScroll.bind(this);
    scrollListener.addScrollListener(this, this.handleScrollListener);
    this.delegateElement.on(
      "keyup",
      '[data-action="search-string"]',
      this.handleSearch.bind(this)
    );
  }

  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();

    // Reset visibility if search input is empty
    if (searchTerm === "") {
      this.termsBlocks.forEach((block) => {
        block.classList.remove("is-hidden");
        const questions = block.querySelectorAll(".faq__block-content");
        questions.forEach((content) => content.classList.remove("is-hidden"));
      });
      this.noResultsElement.classList.add("is-hidden");
      return;
    }

    let hasMatch = false;

    this.termsBlocks.forEach((block) => {
      const title = block.querySelector('.faq__block--heading').textContent.toLowerCase();
      const questions = block.querySelectorAll(".faq__block-content");
      let blockMatch = false;

      if (title.includes(searchTerm)) {
        // If the heading matches, display all content in this block
        block.classList.remove("is-hidden");
        questions.forEach((content) => content.classList.remove("is-hidden"));
        blockMatch = true;
      } else {
        // If only `faq__block-content` matches
        questions.forEach((questionWrapper) => {
          const questionText = questionWrapper.textContent.toLowerCase();
          if (questionText.includes(searchTerm)) {
            questionWrapper.classList.remove("is-hidden");
            blockMatch = true;
          } else {
            questionWrapper.classList.add("is-hidden");
          }
        });

        // Show or hide the block based on matching content
        if (blockMatch) {
          block.classList.remove("is-hidden");
        } else {
          block.classList.add("is-hidden");
        }
      }

      if (blockMatch) hasMatch = true;
    });

    // Display 'no results' message if nothing matched
    if (!hasMatch) {
      this.noResultsElement.classList.remove("is-hidden");
    } else {
      this.noResultsElement.classList.add("is-hidden");
    }
  }

  // Method to handle click events
  handleClick(event) {
    // Set clicked data attribute for managing state
    this.element.dataset.clicked = "true";

    // Remove current highlighting from all links and add it to the clicked one
    const allLinks = this.element.querySelectorAll(".Button");
    allLinks.forEach((item) => item.classList.remove("is-active"));
    event.target.classList.add("is-active");

    // Reset the clicked state after a short delay
    setTimeout(() => {
      this.element.dataset.clicked = "false";
    }, 200);
  }


  // Method to remove all link highlights
  removeAllLinks() {
    const linkedItems = this.element.querySelectorAll(".is-active");
    linkedItems.forEach((item) => item.classList.remove("is-active"));
  }

  handleScroll() {
    // Skip if an item was recently clicked
    if (this.element.dataset.clicked === "true") return;

    // Elements to handle during scroll
    const faqSubheaders = this.element.querySelectorAll(".faq__block--heading");
    const faqMenuTabsWrapper = this.element.querySelectorAll(".faq__linklist--sticky");
    const threshold = 100;

    // Apply shadow effect if viewport size matches 'pocket' breakpoint
    if (new Responsive().matchesBreakpoint("pocket")) {
      faqMenuTabsWrapper.forEach((item) => {
        const distanceFromTop = item.getBoundingClientRect().top;
        item.style.boxShadow = (distanceFromTop <= 52 && distanceFromTop > 0) ?
          "0px 4px 12px 0px rgba(20, 20, 20, 0.10)" : "none";
      });
    }

    // Check if scrolled to the bottom
    const isAtBottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 5;
    if (isAtBottom) {
      // Remove all link highlights and select the last anchor element
      this.removeAllLinks();
      const lastAnchor = this.element.querySelector(".faq__linklist--sticky a:last-of-type");
      if (lastAnchor) lastAnchor.classList.add("is-active");
      return;
    }

    // Loop through subheaders to highlight relevant links based on scroll position
    faqSubheaders.forEach((faqSubheader) => {
      const distanceFromTop = Math.max(0, faqSubheader.getBoundingClientRect().top);

      if (distanceFromTop <= threshold && distanceFromTop > 0) {
        // Remove highlighting from all links and highlight the current section
        this.removeAllLinks();
        const faqSectionId = faqSubheader.closest(".faq__block").id;
        const anchorElements = this.element.querySelectorAll(`a[href="#${faqSectionId}"]`);

        anchorElements.forEach((item) => {
          item.classList.add("is-active");

          // Adjust slide position for mobile view if not in active view
          if (new Responsive().matchesBreakpoint("pocket") && !item.classList.contains("swiper-slide-active")) {
            this.carousel.swiperElement.slideTo(parseInt(item.dataset.index));
          }
        });
      }
    });
  }


}

customElements.define("section-faq", faqSection);

class QuoteSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.enableAnimation = this.element.getAttribute("animation-toggle");
    this.targetParagraph = this.element.querySelector("#quote__paragraph");

    this.runAnimation = this.runAnimation.bind(this);

    if (this.enableAnimation === "true") {
      this.runAnimation();
    }
  }

  runAnimation() {
    if (this.targetParagraph) {
      const textElement = this.targetParagraph;
      const text = textElement.textContent;
      textElement.textContent = "";
      text.split("").forEach((letter) => {
        const span = document.createElement("span");
        span.textContent = letter;
        span.className = "letter";
        textElement.appendChild(span);
      });
      const letters = Array.from(this.element.querySelectorAll(".letter"));
      const animateLetters = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            letters.forEach((letter, index) => {
              setTimeout(() => {
                letter.classList.add("colored");
              }, index * 25);
            });
            observer.unobserve(textElement);
          }
        });
      };

      const observer = new IntersectionObserver(animateLetters, {
        threshold: 0.1,
      });

      observer.observe(textElement);
    }
  }
}
customElements.define("quote-section", QuoteSection);

class BlogShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    new RevolutionSwiper(this.querySelector(".swiper"));
  }
}
customElements.define("blog-showcase", BlogShowcase);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateBody = new Delegate(document.body);

    this.initSwiper();
    this.bindEvents();
    if (this.element.querySelector('[data-print]')) {
      this.changePrice();
    }
  }

  changePrice() {
    const priceElement = this.element.querySelector('[data-print]');
    if (!priceElement) return;
    const price = priceElement.getAttribute('data-print');
    const moneyFormat = window.theme.moneyFormat.replace(/{{[^}]+}}/, '{{ amount }}');
    const newPrice = Shopify.formatMoney(price, moneyFormat);
    priceElement.innerHTML = window.photoPrinterStrings.from.replace('{{ price }}', newPrice);
  }

  bindEvents() {
    responsive.addBreakpointListener("pocket");
    this.delegateBody.on("breakpoint:pocket", this.initSwiper.bind(this));
  }

  initSwiper() {
    if (responsive.matchesBreakpoint("pocket") && !this.swiper) {
      this.swiperElement = this.element.querySelector(".swiper");
      if (!this.swiperElement) return;
      this.swiper = new Swiper(this.swiperElement, {
        slidesPerView: 1,
        lazyPreloadPrevNext: true,
        spaceBetween: 0,
        nested: true,
        resistanceRatio: 0
      });
    } else if (this.swiper && this.swiperElement.swiper) {
      this.swiperElement.swiper.destroy();
      this.swiper = null;
    }
  }
}

customElements.define("product-card", ProductCard);


class mainCart extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    applyPersonalizedCartImages(this.element);
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="update-item-quantity"], [data-action="remove-item"]',
      this.updateItemQuantity.bind(this)
    );
    this.delegateElement.on(
      "change",
      '[data-action="update-change-quantity"]',
      this.updateItemQuantity.bind(this)
    );
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();
    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem.querySelector(".itemLoader");
    itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const payload = {
      id: target.getAttribute("data-line-id"),
      quantity: quantity,
    };

    // Check if this is an original product and update its connected customized item
    const isOriginal = cartItem.dataset.original === "true";

    // Resolve the paired hidden personalized line (if any) so both lines can be updated atomically
    let hiddenLineId = null;
    let hiddenItem = null;
    if (isOriginal && target.dataset.token) {
      const connectedItem = this.element.querySelector(`[data-personalized="true"][data-token="${target.dataset.token}"]`);
      if (connectedItem) {
        const lineIdElement = connectedItem.querySelector('[data-line-id]');
        if (lineIdElement) {
          hiddenLineId = lineIdElement.getAttribute('data-line-id');
          hiddenItem = connectedItem;
        }
      }
    }

    if (quantity === 0 && target.dataset.token) {
      try {
        await apiService.deleteFiles(target.dataset.token, '/api/file/token-delete');
      } catch (error) {
        console.error('Error deleting files:', error);
      }
    }

    // Update the cart using Shopify API — atomic update of both the original and the paired hidden line
    const updates = { [payload.id]: quantity };
    if (hiddenLineId) updates[hiddenLineId] = quantity;

    await fetch(`${window.routes.localeRootUrl}/cart/update.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ updates }),
    });

    if (quantity === 0 && hiddenItem) {
      hiddenItem.remove();
    }

    // Always reload the page for cart page to show updated quantities and prices
    window.location.reload();
  }

  removeItem(event) {


    if (!event.target.dataset.token) return;
    event.preventDefault();
    const token = event.target.dataset.token;
    apiService.deleteFiles(token, '/api/file/token-delete')
      .then(result => {
        event.target.removeAttribute('data-token');
        event.target.click();
      })
      .catch(error => console.error('Error deleting files:', error));


  }
}
customElements.define("main-cart", mainCart);



class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty(
      "--viewport-width",
      `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport-width",
      `${document.documentElement.clientWidth}px`
    );

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

const dynamicVars = new dynamicVariables();

if (!url) {
  var url = window.theme?.backendApiUrl || `https://printworks.coi-agency.services`;
}

class apiServices {
  constructor() {
    this.token = localStorage.getItem("security_token");
    this.timestamp = localStorage.getItem("upload_timestamp");
    this.headers = {
      Authorization: `Bearer ${this.token}`,
      "x-upload-timestamp": this.timestamp,
      "ngrok-skip-browser-warning": 1,
    };
  }

  async regenerateTokens() {
    this.token = localStorage.getItem("security_token");
    this.timestamp =
      localStorage.getItem("upload_timestamp") ||
      (await recoverUploadTimestampForSession(this.token));
    this.headers = {
      Authorization: `Bearer ${this.token}`,
      "ngrok-skip-browser-warning": 1,
    };
    if (this.timestamp) {
      this.headers["x-upload-timestamp"] = this.timestamp;
    }
  }

  // Another class method that calls getUploadToken and processes the response
  async deleteFiles(token, apiUrl, size = null) {
    await this.regenerateTokens();

    const body = { uploadToken: token };
    if (size != null) {
      body.size = size;
    }

    const response = await fetch(`${url}${apiUrl}`, {
      method: "DELETE",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        ...this.headers
      },
      body: JSON.stringify(body)
    });

    const data = await response.json();
    return data;
  }

  async updateMetadata(filename, updates) {
    await this.regenerateTokens();
    try {
      const response = await fetch(`${url}/api/file/update-metadata`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...this.headers
        },
        body: JSON.stringify({
          token: this.token,
          filename,
          updates
        })
      });

      const data = await response.json();

      if (!response.ok) {
        // Return error details if not successful
        return { error: "Failed to update metadata", details: data };
      }

      return data;
    } catch (error) {
      return { error: error.message };
    }
  }

  async getUploadToken(type) {
    try {
      const response = await fetch(`${url}/api/get-token`, {
        method: "POST",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ type: type })
      });
      const data = await response.json();
      return data;
    } catch (error) {
      return { error: error.message };
    }
  }


  async saveEditedImage(size, filename, formData, eanCode) {
    await this.regenerateTokens();
    try {
      // Await the fetch call and assign its response
      const response = await fetch(`${url}/api/file/save-edited`, {
        method: "POST",
        body: formData,
        headers: {
          // Ensure these headers do not include a 'Content-Type' header
          ...this.headers,
          "x-original-filename": filename,
          "x-desired-size": size,
          "x-desired-barcode": eanCode
        }
      });

      const data = await response.json();

      if (!response.ok) {
        // Return error details if not successful
        return { error: "Failed to update image", details: data };
      }

      return data;
    } catch (error) {
      return { error: error.message };
    }
  }

}

const apiService = new apiServices();

/**
 * Sync cart session attributes. When onlyIfMissing is true, never overwrite an
 * existing cart security token that still has upload-session line items.
 */
async function syncUploadCartSessionAttributes(securityToken, timestamp, options = {}) {
  const { onlyIfMissing = false } = options;
  const normalizedToken = securityToken ? String(securityToken) : null;
  const normalizedTimestamp =
    normalizedToken && timestamp ? String(timestamp) : null;

  try {
    if (onlyIfMissing && normalizedToken) {
      const cartResponse = await fetch(`/cart.js?t=${Date.now()}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache",
        },
      });
      if (cartResponse.ok) {
        const cartData = await cartResponse.json();
        const cartToken = cartData.attributes?.private_cart_property;
        const cartTimestamp = cartData.attributes?.private_cart_timestamp;

        if (cartToken === normalizedToken && cartTimestamp) {
          return true;
        }
        if (
          cartToken &&
          cartToken !== normalizedToken &&
          cartNeedsUploadSession(cartData)
        ) {
          return false;
        }
      }
    }

    await fetch(`${window.routes.localeRootUrl}/cart/update.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        attributes: {
          private_cart_property: normalizedToken,
          private_cart_timestamp: normalizedTimestamp,
        },
      }),
    });
  } catch (error) {
    console.warn("Failed to sync cart session attributes", error);
  }
  return true;
}

/**
 * Restore or create upload session tokens without replacing a cart-bound
 * security token (fixes post-refresh 404 while keeping 634313b cart sync).
 */
function shouldBypassSessionStatusOnServerError(sessionStatus, lineItemCount) {
  if (sessionStatus?.ok || !lineItemCount) return false;
  const reason = String(sessionStatus?.reason || "");
  return (
    reason.startsWith("http_5") ||
    reason === "server_error" ||
    reason === "status_check_error"
  );
}

const UPLOAD_SESSION_MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000;

function isUploadTimestampExpired(timestamp) {
  const parsed = Number.parseInt(String(timestamp || ""), 10);
  if (!Number.isFinite(parsed)) {
    return true;
  }
  return Date.now() - parsed > UPLOAD_SESSION_MAX_AGE_MS;
}

/**
 * Restore x-upload-timestamp from cart attributes when localStorage lost it
 * but private_cart_property still matches the active security token.
 */
async function recoverUploadTimestampForSession(securityToken) {
  if (!securityToken) {
    return null;
  }

  const localTs = localStorage.getItem("upload_timestamp");
  if (localTs && !isUploadTimestampExpired(localTs)) {
    return localTs;
  }

  try {
    const cartResponse = await fetch(`/cart.js?t=${Date.now()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
      },
    });
    if (!cartResponse.ok) {
      return localTs || null;
    }
    const cartData = await cartResponse.json();
    const cartToken = cartData.attributes?.private_cart_property || null;
    const cartTs = cartData.attributes?.private_cart_timestamp || null;
    if (cartToken === securityToken && cartTs && !isUploadTimestampExpired(cartTs)) {
      localStorage.setItem("upload_timestamp", cartTs);
      return cartTs;
    }
  } catch (error) {
    console.warn("recoverUploadTimestampForSession failed", error);
  }

  return localTs || null;
}

function uploadSessionBlockMessage(sessionStatus) {
  const reason = String(sessionStatus?.reason || "");
  if (reason.startsWith("http_5")) {
    return "We could not verify your uploads right now. Please try again in a moment.";
  }
  if (reason === "server_error" || reason === "status_check_error") {
    return "We could not verify your uploads right now. Please try again in a moment.";
  }
  if (reason === "network_error") {
    return "Could not reach the upload server. Check your connection and try again.";
  }
  if (reason === "folder_missing" || reason === "no_files_on_disk") {
    return "Upload at least one photo before adding to cart.";
  }
  if (reason === "UPLOAD_SESSION_EXPIRED" || reason === "MISSING_UPLOAD_TIMESTAMP") {
    return "Your upload session expired. Please refresh the page and upload again.";
  }
  return "Upload at least one photo before adding to cart.";
}

function isUploadSessionAuthFailure(sessionStatus) {
  const reason = String(sessionStatus?.reason || "");
  return (
    reason === "UPLOAD_SESSION_EXPIRED" ||
    reason === "MISSING_UPLOAD_TIMESTAMP" ||
    reason === "http_401"
  );
}

/**
 * Cart still references this upload folder (webhook uses cart attrs / line props).
 * Allow checkout when live API auth expired but session was already established.
 */
function shouldBypassSessionStatusForBoundCart(sessionStatus, sessionToken, cartData) {
  if (!sessionStatus || sessionStatus.ok || !sessionToken) {
    return false;
  }
  if (!isUploadSessionAuthFailure(sessionStatus)) {
    return false;
  }
  const cartToken = cartData?.attributes?.private_cart_property || null;
  return Boolean(cartToken && cartToken === sessionToken);
}

function clearUploadSessionStorage() {
  localStorage.removeItem("security_token");
  localStorage.removeItem("upload_timestamp");
  localStorage.removeItem("upload_token");
  uploadSessionReadyToken = null;
  uploadSessionReadyAt = 0;
}

let uploadSessionReadyToken = null;
let uploadSessionReadyAt = 0;

/** Call after uploads finish so ATC can skip repeated session-status polling. */
function markUploadSessionReady(securityToken) {
  if (!securityToken) return;
  uploadSessionReadyToken = String(securityToken);
  uploadSessionReadyAt = Date.now();
}

function invalidateUploadSessionReady() {
  uploadSessionReadyToken = null;
  uploadSessionReadyAt = 0;
}

function countPhotoPrintServerUploads(root = document) {
  const scope =
    root && typeof root.querySelector === "function"
      ? root.querySelector("photo-printing") || root
      : document.querySelector("photo-printing");
  if (!scope) return 0;
  return scope.querySelectorAll(
    ".photo-print__card-wrapper[data-file-server-id]"
  ).length;
}

/**
 * Skip server session-status when this tab already has successful uploads for the token.
 */
function shouldSkipUploadSessionStatusVerify(securityToken, options = {}) {
  const { root = document } = options;
  if (!securityToken) return false;
  if (isUploadSessionRecentlyVerified(securityToken)) return true;
  const localToken = localStorage.getItem("security_token");
  if (localToken !== String(securityToken)) return false;
  return countPhotoPrintServerUploads(root) > 0;
}

function shouldResetSessionAfterStatusFailure(sessionStatus) {
  const reason = String(sessionStatus?.reason || "");
  return (
    reason === "folder_missing" ||
    reason === "no_files_on_disk" ||
    reason === "invalid_token" ||
    reason === "UPLOAD_SESSION_EXPIRED" ||
    reason === "MISSING_UPLOAD_TIMESTAMP" ||
    reason === "http_401"
  );
}

let staleUploadCartPrunePromise = null;

/**
 * Silently remove stale upload cart lines when session/cart disagree with the server.
 * No customer-facing banner — runs once per page load (debounced).
 */
async function pruneStaleUploadCartIfNeeded(cartData) {
  if (!cartData || !cartNeedsUploadSession(cartData)) {
    return cartData;
  }

  const cartToken = cartData.attributes?.private_cart_property || null;
  const cartTimestamp = cartData.attributes?.private_cart_timestamp || null;
  const uploadLineCount = (cartData.items || []).filter(cartItemNeedsUploadSession)
    .length;
  let shouldPrune = false;

  if (!cartToken) {
    shouldPrune = true;
  } else if (cartTimestamp && isUploadTimestampExpired(cartTimestamp)) {
    shouldPrune = true;
  } else if (typeof verifyUploadSessionHasFiles === "function") {
    const sessionStatus = await verifyUploadSessionHasFiles(cartToken, {
      retries: 0,
      delayMs: 0,
    });
    if (sessionStatus.ok) {
      return cartData;
    }
    if (shouldBypassSessionStatusOnServerError(sessionStatus, uploadLineCount)) {
      return cartData;
    }
    if (shouldResetSessionAfterStatusFailure(sessionStatus)) {
      shouldPrune = true;
    }
  }

  if (!shouldPrune) {
    return cartData;
  }

  const updates = {};
  for (const item of cartData.items || []) {
    if (cartItemNeedsUploadSession(item) && item.key) {
      updates[item.key] = 0;
    }
  }

  if (Object.keys(updates).length === 0) {
    await resetUploadSessionForCustomer();
    return cartData;
  }

  try {
    const response = await fetch(`${window.routes.localeRootUrl}/cart/update.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ updates }),
    });
    if (!response.ok) {
      console.warn(
        "pruneStaleUploadCartIfNeeded: cart update failed",
        response.status
      );
      return cartData;
    }
    const updatedCart = await response.json();
    await resetUploadSessionForCustomer();
    await applyUploadSessionCartRules(updatedCart);
    document.dispatchEvent(new CustomEvent("product:added", { bubbles: true }));
    return updatedCart;
  } catch (error) {
    console.warn("pruneStaleUploadCartIfNeeded failed", error);
    return cartData;
  }
}

function runStaleUploadCartPruneOnce(fetchCart) {
  if (!staleUploadCartPrunePromise) {
    staleUploadCartPrunePromise = (async () => {
      try {
        const cartData =
          typeof fetchCart === "function" ? await fetchCart() : fetchCart;
        if (!cartData) return null;
        return await pruneStaleUploadCartIfNeeded(cartData);
      } catch (error) {
        console.warn("runStaleUploadCartPruneOnce failed", error);
        return null;
      } finally {
        staleUploadCartPrunePromise = null;
      }
    })();
  }
  return staleUploadCartPrunePromise;
}

async function resetUploadSessionForCustomer(options = {}) {
  const { clearCartAttributes = true } = options;
  invalidateUploadSessionReady();
  clearUploadSessionStorage();
  if (!clearCartAttributes) return;
  try {
    await fetch(`${window.routes.localeRootUrl}/cart/update.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        attributes: {
          private_cart_property: null,
          private_cart_timestamp: null,
          photo_print_order: null,
        },
      }),
    });
  } catch (error) {
    console.warn("resetUploadSessionForCustomer: cart clear failed", error);
  }
}

/**
 * Prepare session + optional session-status before photo-print ATC.
 */
async function ensureUploadSessionBeforeAtc(options = {}) {
  const { sessionToken: initialToken, root = document, cartData: cartDataIn = null } =
    options;

  if (countPhotoPrintServerUploads(root) === 0) {
    return {
      ok: false,
      reason: "no_client_uploads",
      message: "Upload at least one photo before adding to cart.",
      sessionToken: initialToken,
      sessionStatus: { ok: false, reason: "no_client_uploads" },
    };
  }

  let cartData = cartDataIn;
  try {
    if (!cartData) cartData = await fetchCartJson();
  } catch (error) {
    console.warn("ensureUploadSessionBeforeAtc: cart fetch failed", error);
  }

  if (typeof prepareUploadSessionForApi === "function") {
    await prepareUploadSessionForApi({ cartData });
  }

  let sessionToken =
    localStorage.getItem("security_token") || initialToken || null;
  if (!sessionToken) {
    await resetUploadSessionForCustomer();
    return {
      ok: false,
      reason: "no_token",
      message: "Your upload session expired. Please refresh and upload again.",
      sessionToken: null,
      sessionStatus: { ok: false, reason: "no_token" },
    };
  }

  let sessionStatus = { ok: true, reason: "client_uploads" };
  if (
    typeof verifyUploadSessionHasFiles === "function" &&
    !shouldSkipUploadSessionStatusVerify(sessionToken, { root })
  ) {
    sessionStatus = await verifyUploadSessionHasFiles(sessionToken, {
      retries: 1,
      delayMs: 300,
    });
  }

  if (sessionStatus.ok) {
    markUploadSessionReady(sessionToken);
    return { ok: true, sessionToken, sessionStatus };
  }

  if (shouldBypassSessionStatusOnServerError(sessionStatus, 1)) {
    console.warn("ensureUploadSessionBeforeAtc: proceeding after server error", sessionStatus);
    return { ok: true, sessionToken, sessionStatus };
  }

  if (shouldResetSessionAfterStatusFailure(sessionStatus)) {
    await resetUploadSessionForCustomer();
    return {
      ok: false,
      sessionToken: null,
      sessionStatus,
      message:
        uploadSessionBlockMessage(sessionStatus) +
        " Your session was reset — please upload again.",
      didReset: true,
    };
  }

  return {
    ok: false,
    sessionToken,
    sessionStatus,
    message: uploadSessionBlockMessage(sessionStatus),
  };
}

function isUploadSessionRecentlyVerified(securityToken, maxAgeMs = 5 * 60 * 1000) {
  return (
    Boolean(securityToken) &&
    uploadSessionReadyToken === String(securityToken) &&
    Date.now() - uploadSessionReadyAt < maxAgeMs
  );
}

async function fetchCartJson() {
  const response = await fetch(`/cart.js?t=${Date.now()}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
    },
  });
  if (!response.ok) {
    throw new Error(`cart fetch ${response.status}`);
  }
  return response.json();
}

function cartHasUploadLineItems(cartData) {
  return (cartData?.items || []).some((item) => {
    const props = item?.properties || {};
    return (
      props._is_photo_print === "true" ||
      props._personalized ||
      props._personalized_album ||
      props._is_original === "true"
    );
  });
}

/**
 * Pre-May-27 rules: cart private_cart_property is source of truth when the cart has
 * upload products; drop stale local sessions when the cart is empty or unrelated.
 */
async function applyUploadSessionCartRules(cartData) {
  if (!cartData) {
    return {
      securityToken: localStorage.getItem("security_token"),
      timestamp: localStorage.getItem("upload_timestamp"),
    };
  }

  const cartSecurityToken = cartData.attributes?.private_cart_property || null;
  const cartTimestamp = cartData.attributes?.private_cart_timestamp || null;
  const hasCartSecurityToken = Boolean(
    cartSecurityToken && String(cartSecurityToken).trim()
  );
  const hasCartTimestamp = Boolean(cartTimestamp && String(cartTimestamp).trim());
  const hasUploadLineItems = cartHasUploadLineItems(cartData);

  if (cartData.item_count === 0 || !hasUploadLineItems) {
    if (hasCartSecurityToken) {
      try {
        await fetch(`${window.routes.localeRootUrl}/cart/update.js`, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            attributes: {
              private_cart_property: null,
              private_cart_timestamp: null,
              photo_print_order: null,
            },
          }),
        });
      } catch (error) {
        console.warn("applyUploadSessionCartRules: cart attribute clear failed", error);
      }
    }
    clearUploadSessionStorage();
    return { securityToken: null, timestamp: null };
  }

  let securityToken = localStorage.getItem("security_token");
  let timestamp = localStorage.getItem("upload_timestamp");

  if (hasCartSecurityToken) {
    const localTokenBeforeSync = securityToken;
    if (!securityToken) {
      localStorage.setItem("security_token", cartSecurityToken);
      securityToken = cartSecurityToken;
    } else if (securityToken !== cartSecurityToken) {
      localStorage.setItem("security_token", cartSecurityToken);
      securityToken = cartSecurityToken;
    }

    if (
      hasCartTimestamp &&
      (!timestamp || localTokenBeforeSync !== cartSecurityToken)
    ) {
      localStorage.setItem("upload_timestamp", cartTimestamp);
      timestamp = cartTimestamp;
    } else if (timestamp && !hasCartTimestamp) {
      await syncUploadCartSessionAttributes(cartSecurityToken, timestamp);
    }
  } else if (securityToken) {
    clearUploadSessionStorage();
    securityToken = null;
    timestamp = null;
  }

  return { securityToken, timestamp };
}

/**
 * Restore session headers before any upload API call (cart timestamp, mint missing upload token).
 */
async function prepareUploadSessionForApi(options = {}) {
  const tokens = await ensureUploadSessionTokens(options);
  return {
    securityToken: tokens.securityToken,
    timestamp: tokens.timestamp,
    uploadToken: tokens.uploadToken,
    authReady: Boolean(
      tokens.securityToken &&
        tokens.timestamp &&
        !isUploadTimestampExpired(tokens.timestamp)
    ),
  };
}

async function verifyUploadSessionHasFiles(securityToken, options = {}) {
  const { retries = 2, delayMs = 1500 } = options;
  const baseUrl = window.theme?.backendApiUrl || "https://printworks.coi-agency.services";
  if (!securityToken) {
    return { ok: false, reason: "no_token" };
  }

  let lastStatus = { ok: false, reason: "unknown" };
  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      const uploadTimestamp =
        localStorage.getItem("upload_timestamp") ||
        (await recoverUploadTimestampForSession(securityToken));
      const sessionStatusHeaders = {
        Authorization: `Bearer ${securityToken}`,
        "Cache-Control": "no-cache, no-store, must-revalidate",
      };
      if (uploadTimestamp) {
        sessionStatusHeaders["x-upload-timestamp"] = uploadTimestamp;
      }
      const response = await fetch(`${baseUrl}/api/file/session-status`, {
        method: "GET",
        headers: sessionStatusHeaders,
      });
      if (!response.ok) {
        try {
          const errBody = await response.json();
          lastStatus = {
            ok: false,
            reason: errBody.code || errBody.reason || `http_${response.status}`,
            imageFileCount: errBody.imageFileCount,
          };
        } catch (parseErr) {
          lastStatus = { ok: false, reason: `http_${response.status}` };
        }
        if (
          isUploadSessionAuthFailure(lastStatus) &&
          attempt < retries
        ) {
          const recoveredTs = await recoverUploadTimestampForSession(securityToken);
          if (recoveredTs) {
            localStorage.setItem("upload_timestamp", recoveredTs);
            continue;
          }
        }
      } else {
        lastStatus = await response.json();
        if (lastStatus.ok) {
          return lastStatus;
        }
      }
    } catch (error) {
      console.warn("verifyUploadSessionHasFiles failed", error);
      lastStatus = { ok: false, reason: "network_error" };
    }
    if (attempt < retries) {
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
  }
  return lastStatus;
}

/**
 * Sync localStorage with cart upload session attributes (cart wins on mismatch).
 */
async function reconcileUploadSessionWithCart() {
  let cartData = null;
  try {
    const response = await fetch(`/cart.js?t=${Date.now()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
      },
    });
    if (!response.ok) {
      throw new Error(`cart fetch ${response.status}`);
    }
    cartData = await response.json();
  } catch (error) {
    console.warn("reconcileUploadSessionWithCart: cart fetch failed", error);
    return {
      securityToken: localStorage.getItem("security_token"),
      timestamp: localStorage.getItem("upload_timestamp"),
      cartData: null,
    };
  }

  const prunedCart =
    (await runStaleUploadCartPruneOnce(() => cartData)) || cartData;
  const applied = await applyUploadSessionCartRules(prunedCart);
  return { ...applied, cartData: prunedCart };
}

async function ensureUploadSessionTokens(options = {}) {
  let cartData = options.cartData || null;
  try {
    if (!cartData) {
      cartData = await fetchCartJson();
    }
    cartData = (await runStaleUploadCartPruneOnce(() => cartData)) || cartData;
    await applyUploadSessionCartRules(cartData);
  } catch (error) {
    console.warn("ensureUploadSessionTokens: cart session check failed", error);
  }

  const recovered = await recoverCartSessionTokens();

  let securityToken =
    localStorage.getItem("security_token") || recovered.securityToken;
  let timestamp =
    localStorage.getItem("upload_timestamp") || recovered.timestamp;
  let uploadToken = localStorage.getItem("upload_token");

  if (securityToken && !timestamp) {
    timestamp = await recoverUploadTimestampForSession(securityToken);
  }

  const needsSecurityToken = !securityToken;
  const needsUploadToken = !uploadToken;

  if (needsSecurityToken && needsUploadToken) {
    const response = await apiService.getUploadToken("both");
    securityToken = response.securityToken;
    timestamp = response.timestamp || Date.now().toString();
    uploadToken = response.uploadToken;

    if (securityToken) {
      localStorage.setItem("security_token", securityToken);
    }
    if (timestamp) {
      localStorage.setItem("upload_timestamp", timestamp);
    }
    if (uploadToken) {
      localStorage.setItem("upload_token", uploadToken);
    }
    await syncUploadCartSessionAttributes(securityToken, timestamp);
    return { securityToken, timestamp, uploadToken };
  }

  if (needsSecurityToken) {
    const response = await apiService.getUploadToken("security");
    securityToken = response.securityToken;
    timestamp = response.timestamp || Date.now().toString();

    if (securityToken) {
      localStorage.setItem("security_token", securityToken);
    }
    if (timestamp) {
      localStorage.setItem("upload_timestamp", timestamp);
    }
    await syncUploadCartSessionAttributes(securityToken, timestamp);
    uploadToken = localStorage.getItem("upload_token");
    return { securityToken, timestamp, uploadToken };
  }

  if (needsUploadToken) {
    const response = await apiService.getUploadToken("upload");
    uploadToken = response.uploadToken;
    localStorage.setItem("upload_token", uploadToken);
  }

  if (securityToken && !timestamp) {
    timestamp = await recoverUploadTimestampForSession(securityToken);
  }

  if (securityToken && timestamp) {
    await syncUploadCartSessionAttributes(securityToken, timestamp, {
      onlyIfMissing: true,
    });
  }

  return {
    securityToken: localStorage.getItem("security_token"),
    timestamp: localStorage.getItem("upload_timestamp"),
    uploadToken: localStorage.getItem("upload_token"),
  };
}

document.addEventListener("DOMContentLoaded", () => {
  runStaleUploadCartPruneOnce(fetchCartJson).then((cartData) => {
    if (cartData) {
      applyUploadSessionCartRules(cartData);
    }
  });
});

class PersonalizationPreview extends HTMLElement {
  constructor() {
    super();
    this.canvas = null;
    this.textboxes = [];
    this.coverImageObj = null;
    this.element = this;
    this.bgImage = null;
    this.fontLoaded = false;

    // Define base reference size (same as modal)
    this.BASE_CANVAS_SIZE = 421;
  }

  connectedCallback() {
    this.preloadFont();
    this.checkLoaded();
  }

  async preloadFont() {
    const fontFamily = this.dataset.fontFamily;
    const fontUrl = this.dataset.fontUrl;

    // If no font or it's Arial, mark as loaded immediately
    if (!fontFamily || !fontUrl || fontFamily === "Arial") {
      this.fontLoaded = true;
      return;
    }

    try {
      const fontFace = new FontFace(fontFamily, `url(${fontUrl})`);
      const loadedFont = await fontFace.load();
      document.fonts.add(loadedFont);
      this.fontLoaded = true;
    } catch (err) {
      console.warn(`Failed to load font ${fontFamily}:`, err);
      this.fontLoaded = true;
    }
  }

  checkLoaded() {
    if (this.canvas) {
      this.resizeCanvas();
      return;
    }

    if (typeof fabric !== "undefined") {
      // Wait for font to be loaded before initializing canvas
      if (this.fontLoaded) {
        this.initCanvas();
      } else {
        setTimeout(() => this.checkLoaded(), 50);
      }
    } else {
      // Load fabric.js if not available
      if (window.theme && window.theme.fabricScript) {
        loadScript(window.theme.fabricScript);
        setTimeout(() => this.checkLoaded(), 100);
      } else {
        console.warn(
          "Fabric.js script URL not found in window.theme.fabricScript"
        );
      }
    }
  }

  initCanvas() {
    const canvasEl = this.querySelector("#preview-fabric-canvas");
    if (!canvasEl) {
      console.error("Canvas element not found");
      return;
    }

    this.canvas = new fabric.Canvas(canvasEl, {
      selection: false,
      preserveObjectStacking: true,
    });

    // Load background image
    const imageUrl = this.dataset.img;
    if (imageUrl) {
      const img = new Image();
      img.crossOrigin = "Anonymous";

      img.onload = () => {
        this.fabricImg = new fabric.Image(img, {
          left: 0,
          top: 0,
          selectable: false,
          evented: false,
        });

        this.fabricImg.isBgImage = true;
        this.canvas.add(this.fabricImg);
        this.canvas.renderAll();
        this.resizeCanvas();
      };

      img.onerror = () => {
        console.error("Failed to load background image:", imageUrl);
      };

      img.src = imageUrl;
    } else {
      // No background image, just setup canvas
      this.resizeCanvas();
    }

    // Setup resize observer
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.resizeCanvas();
      });
      this.resizeObserver.observe(this);
    }
  }

  getScaleFactor() {
    const currentSize = Math.round(this.canvas.width);
    return currentSize / this.BASE_CANVAS_SIZE;
  }

  // Method to be used in your modal as well
  calculateTextboxPosition(
    canvasWidth,
    canvasHeight,
    xCoordinate,
    yCoordinate,
    textWidth,
    textAlignment
  ) {
    // Calculate positioning using the same logic as the preview
    const tbWidth = Math.round((textWidth / 100) * canvasWidth * 2) / 2;

    // Position text box to match the red overlay positioning
    // The red overlay uses CSS positioning from center, so we need to adjust for that
    const centerX = (xCoordinate / 100) * canvasWidth;
    const centerY = (yCoordinate / 100) * canvasHeight;

    // ALWAYS center the textbox container - let Fabric.js textAlign handle the alignment within
    const leftPosition = centerX - tbWidth / 2;

    return {
      leftPosition: leftPosition,
      centerY: centerY,
      tbWidth: tbWidth,
    };
  }

  addTextboxes() {
    // Clear existing textboxes
    this.textboxes.forEach((tb) => this.canvas.remove(tb));
    this.textboxes = [];

    // Get settings from data attributes
    const row1Text = this.dataset.row1 || "";
    const row2Text = this.dataset.row2 || "";
    const xCoordinate = parseFloat(this.dataset.xCoordinate || "16");
    const yCoordinate = parseFloat(this.dataset.yCoordinate || "16");
    const textWidth = parseFloat(this.dataset.textWidth || "100");
    const rowGap = parseFloat(this.dataset.rowGap || "16");
    const textSize = parseFloat(this.dataset.textSize || "16");
    const textAlignment = this.dataset.textAlignment || "left";
    const fontFamily = this.dataset.fontFamily || "Arial";
    const fontFamilyUrl = this.dataset.fontUrl || "";
    const textColor = this.dataset.textColor || "#000000";

    const canvasWidth = this.canvas.width;
    const canvasHeight = this.canvas.height;
    const scaleFactor = this.getScaleFactor();
    const scaledFontSize = textSize * scaleFactor;

    // Use the shared positioning calculation
    const positioning = this.calculateTextboxPosition(
      canvasWidth,
      canvasHeight,
      xCoordinate,
      yCoordinate,
      textWidth,
      textAlignment
    );

    // Store the center Y for positioning calculations
    this.baseY = positioning.centerY;

    // Create textboxes for both rows (even if empty)
    const texts = [row1Text, row2Text];

    for (let i = 0; i < 2; i++) {
      const tb = new fabric.Textbox(texts[i] || "", {
        left: positioning.leftPosition,
        top: positioning.centerY, // Will be adjusted in updateTextboxPositions
        width: positioning.tbWidth,
        letterSpacing: 0,
        textAlign: textAlignment,
        fontFamily: fontFamily,
        fontSize: scaledFontSize,
        fill: textColor,
        editable: false,
        lockScalingX: true,
        lockScalingY: true,
        hasControls: false,
        selectable: false,
        breakWords: false,
        splitByGrapheme: false,
      });

      tb.baseFont = textSize;
      tb.scaledFont = scaledFontSize;
      tb.minWidth = positioning.tbWidth;
      tb.set("height", scaledFontSize);

      // Override width calculation method to prevent expansion
      tb._getWidthOfCharSpacing = function () {
        return 0;
      };

      // Force width to never exceed the set value
      tb.on("text:changed", function () {
        if (this.width > positioning.tbWidth) {
          this.set("width", positioning.tbWidth);
          this.setCoords();
        }
      });

      // Override height calculation methods
      tb.getHeightOfLine = function () {
        return this.fontSize;
      };

      tb._getHeightOfLine = function () {
        return this.fontSize;
      };

      this.canvas.add(tb);
      this.textboxes.push(tb);
    }

    this.updateTextboxPositions();
  }

  addCoverImage() {
    if (this.coverImageObj) {
      this.canvas.remove(this.coverImageObj);
      this.coverImageObj = null;
    }

    const coverImageUrl = this.dataset.coverImagePreview;
    const coverWidth = parseFloat(this.dataset.coverImageWidth || "0");
    if (!coverImageUrl || coverWidth === 0) return;

    if (this._coverImgEl && this._coverImgEl.src === coverImageUrl) {
      this._placeCoverImage(this._coverImgEl, coverWidth);
      return;
    }

    const img = new Image();
    img.crossOrigin = "Anonymous";

    img.onload = () => {
      this._coverImgEl = img;
      this._placeCoverImage(img, coverWidth);
    };

    img.onerror = () => {
      console.error("Failed to load cover image:", coverImageUrl);
    };

    img.src = coverImageUrl;
  }

  _placeCoverImage(img, coverWidth) {
    if (this.coverImageObj) {
      this.canvas.remove(this.coverImageObj);
    }

    const coverX = parseFloat(this.dataset.coverImageX || "50");
    const coverY = parseFloat(this.dataset.coverImageY || "50");
    const coverAspectRatioRaw = this.dataset.coverImageAspectRatio || "";
    const canvasWidth = this.canvas.width;
    const canvasHeight = this.canvas.height;

    const targetWidth = (coverWidth / 100) * canvasWidth;

    // Parse aspect ratio — mirrors album-cover.js parseAspectRatioValue exactly
    let parsedRatio = null;
    if (coverAspectRatioRaw) {
      const raw = String(coverAspectRatioRaw).trim();
      if (raw.includes(":")) {
        const [w, h] = raw.split(":").map((v) => parseFloat(v.trim()));
        if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) parsedRatio = w / h;
      } else if (raw.includes("/")) {
        const [w, h] = raw.split("/").map((v) => parseFloat(v.trim()));
        if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) parsedRatio = w / h;
      } else {
        const r = parseFloat(raw);
        if (Number.isFinite(r) && r > 0) parsedRatio = r;
      }
    }
    const naturalRatio = img.naturalWidth / img.naturalHeight;
    const ratioToUse = parsedRatio || naturalRatio;
    const targetHeight = targetWidth / ratioToUse;

    // Single source of truth for cover box placement.
    const clampedX = Math.min(100, Math.max(0, coverX));
    const clampedY = Math.min(100, Math.max(0, coverY));
    const maxLeft = Math.max(0, canvasWidth - targetWidth);
    const maxTop = Math.max(0, canvasHeight - targetHeight);
    const left = (clampedX / 100) * maxLeft;
    const top = (clampedY / 100) * maxTop;

    // Keep DOM debug overlay in perfect sync with Fabric box.
    const coverOverlayEl = this.querySelector(
      ".personalization-preview__cover-image-overlay"
    );
    if (coverOverlayEl) {
      coverOverlayEl.style.left = `${left}px`;
      coverOverlayEl.style.top = `${top}px`;
      coverOverlayEl.style.width = `${targetWidth}px`;
      coverOverlayEl.style.height = `${targetHeight}px`;
      coverOverlayEl.style.aspectRatio = "auto";
    }

    // Object-fit: cover — same as editor
    const scale = Math.max(
      targetWidth / img.naturalWidth,
      targetHeight / img.naturalHeight
    );
    const scaledWidth = img.naturalWidth * scale;
    const scaledHeight = img.naturalHeight * scale;

    // Offset image within clip box — same as editor
    const drawLeft = left + (targetWidth - scaledWidth) / 2;
    const drawTop = top + (targetHeight - scaledHeight) / 2;

    const clipRect = new fabric.Rect({
      left,
      top,
      width: targetWidth,
      height: targetHeight,
      absolutePositioned: true,
    });

    this.coverImageObj = new fabric.Image(img, {
      left: drawLeft,
      top: drawTop,
      scaleX: scale,
      scaleY: scale,
      clipPath: clipRect,
      selectable: false,
      evented: false,
    });

    this.coverImageObj.isCoverImage = true;
    this.canvas.add(this.coverImageObj);

    // Place above background but behind text
    const objects = this.canvas.getObjects();
    const bgIndex = objects.findIndex((obj) => obj.isBgImage);
    if (bgIndex >= 0) {
      this.coverImageObj.moveTo(bgIndex + 1);
    }

    this.canvas.renderAll();
  }

  updateTextboxPositions() {
    if (!this.canvas || this.textboxes.length === 0) return;

    const rowGap = parseFloat(this.dataset.rowGap || "16");
    const scaleFactor = this.getScaleFactor();
    const scaledRowGap = rowGap * scaleFactor;
    const baseY = this.baseY;

    // Count filled textboxes (non-empty text)
    const filledTextboxes = this.textboxes.filter(
      (tb) => tb.text && tb.text.trim() !== ""
    );

    if (filledTextboxes.length === 0) {
      // No text - position all textboxes at base position
      this.textboxes.forEach((tb) => {
        tb.set("top", baseY);
      });
    } else if (filledTextboxes.length === 1) {
      // Only one row filled - center it vertically at the specified Y coordinate
      const filledTb = filledTextboxes[0];
      filledTb.set("top", baseY - filledTb.height / 2);

      // Hide/position the empty textbox at the same location
      const emptyTb = this.textboxes.find(
        (tb) => !tb.text || tb.text.trim() === ""
      );
      if (emptyTb) {
        emptyTb.set("top", baseY - emptyTb.height / 2);
      }
    } else if (filledTextboxes.length === 2) {
      // Both rows filled - distribute around the base Y coordinate
      const tb1 = this.textboxes[0];
      const tb2 = this.textboxes[1];

      // Calculate total height needed for both textboxes and gap
      const totalHeight = tb1.height + tb2.height + scaledRowGap;

      // Center the total height around the base Y coordinate
      const startY = baseY - totalHeight / 2;

      tb1.set("top", startY);
      tb2.set("top", startY + tb1.height + scaledRowGap);
    }

    // Update coordinates and render
    this.textboxes.forEach((tb) => tb.setCoords());
    this.canvas.renderAll();
  }

  resizeCanvas() {
    const container = this.querySelector(
      ".personalization-preview__canvas-container"
    );
    if (!container) {
      console.warn("Container not found");
      return false;
    }

    const containerWidth = parseFloat(
      window.getComputedStyle(container).getPropertyValue("width")
    );

    if (!containerWidth || containerWidth === 0) {
      console.warn("Container width is 0");
      return false;
    }

    this.canvas.setWidth(containerWidth);
    this.canvas.setHeight(containerWidth);

    // Scale background image if exists
    const bgImage = this.canvas.getObjects().find((obj) => obj.isBgImage);
    if (bgImage) {
      const imgWidth = bgImage._element.naturalWidth;
      const imgHeight = bgImage._element.naturalHeight;
      const scale = Math.max(
        containerWidth / imgWidth,
        containerWidth / imgHeight
      );

      bgImage.scale(scale);
      bgImage.set({
        left: (containerWidth - bgImage.getScaledWidth()) / 2,
        top: (containerWidth - bgImage.getScaledHeight()) / 2,
      });
      bgImage.setCoords();
    }

    this.addCoverImage();
    this.addTextboxes();
    this.canvas.renderAll();

    return true;
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}

customElements.define("personalization-preview", PersonalizationPreview);

class UspPdp extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll('.swiper-slide');

    if (this.slides.length > 5) {
      new RevolutionSwiper(this);
    }
  }

  connectedCallback() {
  }
}
customElements.define("usp-pdp", UspPdp);